// openlayers section
import OlCollection from 'ol/Collection.js';
import {click as OlEventsConditionClick, shiftKeyOnly as OlEventsConditionShiftKeyOnly, singleClick as OlEventsConditionSingleClick} from 'ol/events/condition.js';
import {MousePosition as OlControlMousePosition, defaults as OlControlDefaults, ZoomSlider as OlControlZoomSlider} from 'ol/control.js';
import {format as OlCoordinateFormat} from 'ol/coordinate.js';
import OlFeature from 'ol/Feature.js';
import {GeoJSON as OlFormatGeoJSON } from 'ol/format.js'
import {Point as OlGeomPoint, LineString as OlGeomLineString} from 'ol/geom.js';
import {Draw as OlInteractionDraw, Modify as OlInteractionModify, Select as OlInteractionSelect, defaults as OlInteractionDefaults, MouseWheelZoom as OlMouseWheelZoom } from 'ol/interaction';
import {Group as OlLayerGroup, Image as OlLayerImage, Vector as OlLayerVector, Tile as OlLayerTile, VectorTile as OlLayerVectorTile} from 'ol/layer.js';
import OlMap from 'ol/Map.js';
import {BingMaps as OlSourceBingMaps, ImageStatic as OlSourceImageStatic, OSM as OlSourceOSM, Vector as OlSourceVector, VectorTile as OlSourceVectorTile, XYZ as OlSourceXYZ, TileWMS as OlSourceTileWMS, ImageWMS as OlSourceImageWMS} from 'ol/source.js';
import OlGraticule from 'ol/layer/Graticule.js';
import {transform as OlProjTransform, transformExtent as OlProjTransformExtent} from 'ol/proj.js';
import {register as OlProjProj4Register} from 'ol/proj/proj4.js';
import {getDistance as OlSphereGetDistance} from 'ol/sphere.js';
import {Circle as OlStyleCircle, Fill as OlStyleFill, Stroke as OlStyleStroke, Style as OlStyleStyle, Text as OlStyleText} from 'ol/style.js';
import {createXYZ as OlTilegridCreateXYZ} from 'ol/tilegrid.js';
import OlView from 'ol/View.js';
// import proj4
import proj4 from 'proj4';
// import jquery
import jquery from 'jquery';
export default (window.$ = window.jQuery = jquery)
// import turf
import * as turf from '@turf/turf';
// import jsPDF
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './GenYoGothicTW-Regular-normal.js';

// import version control
import {default as VersionControlled} from './versioncontrol.js';
// those two for IE11 (promise async await fetch)
import "@babel/polyfill";
import 'whatwg-fetch';


export function inivar(tmpIni){
  // set up coord transform below(3826) was obtained from https://epsg.io/3826-1753.js
  // TWD97 119
  proj4.defs("EPSG:3825","+proj=tmerc +lat_0=0 +lon_0=119 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
  // TWD97 121
  proj4.defs("EPSG:3826","+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
  // TWD67 119
  proj4.defs("EPSG:3827","+proj=tmerc +lat_0=0 +lon_0=119 +k=0.9999 +x_0=250000 +y_0=0 +ellps=aust_SA +units=m +no_defs");
  // TWD67 121
  proj4.defs("EPSG:3828","+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=aust_SA +units=m +no_defs");
  OlProjProj4Register(proj4);

  var gvar={}
  //gvar.staticUrl=tmpIni.staticUrl
  gvar.staticUrl='/odbintl/static/';
  //console.log(tmpIni.staticUrl)
  gvar.imgMapArr=[];
  gvar.grpBaseMaps=iniMaps();
  gvar.Layers=iniLayers();
  gvar.chkShipSpdByHrs=false;
  gvar.chkShowSiteName=true;
  gvar.ptID4highlight=0;
  gvar.chkMapModify=true;
  gvar.zoomDelta=0.1;// zoomdelta when click the +- on the map for zoom in/out
  gvar.cPlanInfo={
    'rv':9,//'2:or1, 9:nor1 ',
    'datetime_dep': moment(new Date()).format('YYYY-MM-DD 10:00'),
    'proj_name': '',
    'specialNeed':'',
    'work_dock_chk':false,
    'bigItems':'',
    'enter_sensitive_sea_areas':false, //modified by cywhale SenSea
    'chk_allow_sensea':false,
    'ent_sensea_lon':'',
    'ent_sensea_lat':'',
    'dep_sensea_lon':'',
    'dep_sensea_lat':'',
    'ent_sensea_datetime': '', //moment(new Date()).format('YYYY-MM-DD 10:00'),
    'dep_sensea_datetime': ''  //moment(new Date()).format('YYYY-MM-DD 10:00')
  };
  gvar.wkItem={};
  $.getJSON('/odbintl/rasters/getWorkItem/', function(data) {
    gvar.wkItem=data;
  });
  gvar.cplanHistFeatures={}
  gvar.olfeatures = new OlCollection();
  gvar.selectedfeatures=new OlCollection();
  gvar.HighlightTPtracks=[]
  gvar.cplanlinesource=new OlSourceVector({});
  gvar.olstyleFunction=styleFunction;
  gvar.olpointsOverlay= new OlLayerVector({
    name: 'points',
    source: new OlSourceVector({features: gvar.olfeatures}),
    style: gvar.olstyleFunction,
    renderMode:'image'
  });

  gvar.pt4highlight= new OlLayerVector({
    name: 'pt4highlight',
    source: new OlSourceVector({features: gvar.selectedfeatures}),
    style: highlightStyleFunction,
    renderMode:'image'
  });
  gvar.SchData={};
  gvar.StaData={};
  //gvar.StaData.point=[];
  //gvar.StaData.point.push([" ID","Longitude","Latitude","Name", "Stay Hours","Point Inline", "Work Item"]);
  //gvar.StaData.point.push([" ID","Longitude","Latitude","Name", "Point Inline"]);
  //gvar.StaData.line=[];
  gvar.StaData.ptHead=[" ID","Longitude","Latitude","Name", "Point Inline"];
  gvar.SchData.lineHead=["ID","距離(nm)","船速(節)","航時(hr)","作業時間","作業項目"];
  gvar.SchData.line=gvar.SchData.lineHead;
  /*
  gvar.cPlanJSON={
    'points':gvar.StaData.point,
    'line':gvar.SchData.line,
    'cPlanName':'',
    'cPlanInfo':gvar.cPlanInfo
  }
  */
  gvar.cPlanJSON={ //這個變數會用來進行復原及取消復原，目前只考慮點及線。
    'points':[],
    'line':[],
//    'cPlanName':'',
//    'cPlanInfo':gvar.cPlanInfo
  }
  gvar.cPlanName='';
  gvar.cPlanJSON.points.push(gvar.StaData.ptHead);
  gvar.cPlanJSON.line.push(gvar.SchData.lineHead);
  gvar.cPlanVC= new VersionControlled(gvar.cPlanJSON)
  gvar.cPlanJSON=gvar.cPlanVC.data;
  gvar.UndoArr=[];
  gvar.oldrawcplan;
  var pointsSource=gvar.olpointsOverlay.getSource()
  gvar.points = pointsSource.getFeatures();
  gvar.autoID=-1;
  gvar.autoSchID=0;
  gvar.tmpNr=-1;
  // 列出三船的全部的隨船設備，之後再根據各別船隻選相應的。
  // 這樣子在切換三船時，原來的資訊才容易保留。  
  gvar.equipments={"1":["溫鹽深儀(SBE 9/11plus CTD)",false],
    "2":["溶氧探針(SBE43 DO sensor)",false],
    "3":["螢光探針(CI Fluorometer)",false],
    "4":["透光度探針(CI Transmissometer )",false],          
    "5":["光度計 (CI PAR)",false],
    "6":["輪盤採水器(SBE32 12支型)",false],
    "7":["輪盤採水器(SBE32 24支型)",false],
    "8":["表面溫鹽儀 (SBE21 Thermosalinograph)",false],  
    "9":["螢光探針(WET Labs Fluorometer)",false],             
    "10":["透光度探針(WET Labs Transmissometer)",false],
    "11":["可見光亮度計 (Biospherical Surface PAR)",false],
    "12":["船碇式流剖儀 (TRDI ADCP 75kHz & 150KHz)",false],
    "13":["科學漁探儀 (EK80 38KHz & 120KHz & 200KHz)",false],    
    "14":["單音束測深儀 (EA640 12KHz & 38KHz & 200KHz)",false],
    "15":["多音束測深儀(EM2040 & EM304)",false],
    "16":["淺層高解析地層剖析儀(Edgetech 3300)",false],
    "17":["重力儀(Air-Sea Gravity System II)",false],         
    "18":["拋棄式溫深儀(XBT) (不含XBT彈)",false],     
    "19":["繫纜式聲速剖面儀(MIDAS  SVP)",false],
    "20":["水下定位系統(Hi PAP)",false],
    "21":["命令釋放器音鼓(ORE 8011M Acoustic Transceiver)\n (不含命令釋放器)",false],  
    "22":["旋轉式採泥器(Wildco Shiptek)",false], 
    "23":["箱型岩心採樣器(Box core)",false],
    "24":["重力岩心採樣器(Gravity core)",false],
    "25":["活塞岩心採樣器(Piston core)",false],
    "26":["複管式沈積物採樣器(Multiple core)",false],
    "27":["標準配置：20L X-Niskin 採水瓶 12 支",false],
    "28":["其他需求：請直接與貴儀中心負責人員聯絡\n    電話：(02)2363-8907 王漢松 先生",false],
    "29":["下小艇(如申請工作小艇，工作小艇架將安裝於主甲板固定位子)",false]}
  return gvar;
}

function iniMaps(){
  var Maps={}
  Maps.osm = new OlLayerTile({
    name: 'OSM',
    title: 'OSM',
    visible: false,
    source: new OlSourceOSM()
  })
  Maps.odbBasemap = new OlLayerTile({
    name: 'odbBasemap',
    visible: false,
    source: new OlSourceXYZ({
      //url: '../tiles/Tai_02/{z}/{x}/{y}.tif'
      url: '/odbintl/rasters/tiles/odb_dep/{z}/{x}/{y}.tif'
    })
  });
  Maps.bingmap = new OlLayerTile({
    name: 'Bing',
    visible: true,
    source: new OlSourceBingMaps({
      imagerySet: 'Aerial',
      key: 'ApfjIfSlbgg3KiOkyfjMT5Q5IWoLakhMkhpAiLJydgqT3gZB6CCHArHBKjqdsAZa'
    })
  });
  Maps.MOIMAP=new OlLayerTile({
    name:'MOIMAP',
    visible: false,
    //opacity: 0.8,
    source: new OlSourceTileWMS({
      url: 'https://wms.nlsc.gov.tw/wms',
            params: {
              'LAYERS': 'EMAP',
              'VERSION':'1.0.0'
            }
          })
        })
  var grpBaseMaps=new OlLayerGroup({
    name: 'BasemapGroup',
    layers: [Maps.bingmap, Maps.osm, Maps.odbBasemap, Maps.MOIMAP]
  })
  return grpBaseMaps;
}

export function main(){
  let tmpobj={}
  JoyrideInfo();
  set_sidebar_interaction();
  tmpobj.map=set_map();
  gvar.map=tmpobj.map;
  setMapInteraction();
  setTableInteraction();
  buildLayerList('Layers4AuthUser',gvar.layers4AuthUser);
  buildLayerList('Layers4All',gvar.layers4All);
  setHtmlInteraction();
  setMapModalInteraction(tmpobj.map);
  applyInitialUIState();
  applyMargins();
  iniSchTable();
  iniShipTrackLayerList();
//$('.navbar-brand').click(function(){JSONVC()})
  return tmpobj
}
function buildLayerList(objId,layerNames){
  let tmpStr
  let LIobj;
  var lyrN;
  let tmpObj=$('#'+objId);
  if (tmpObj.length){
    for (let i=0; i<layerNames.length; ++i){
      lyrN=gvar.Layers[layerNames[i]].get('name');
      tmpStr='<li>&nbsp;&nbsp;&nbsp;';
      tmpStr+='<input type="checkbox" id=';
      tmpStr+='"'+"is"+lyrN+"Selected"+'"' ;
      tmpStr+=' class="fancy-check"/>'
      tmpStr+= gvar.Layers[layerNames[i]].get('desc_cn')
      tmpStr+='</li>'
      LIobj=$(tmpStr);
      tmpObj.before(LIobj);
      $('#'+"is"+lyrN+"Selected").click(function(){
        switchLayer(gvar.Layers[layerNames[i]].get('name'));
      })
    }
  }
}
export function set_map(){
  gvar.layers4AuthUser=[
    'odbBasemap', 'odb_temperature_30m', 'odb_current_20m',
    'Cplan','TyphoonTracks', 'PhilippinesEEZ'
  ];
  gvar.layers4All=[
    'olgraticule','Himawari8', 'ECMWF', 'GeoName', 
      /*'CN_24nm_line',*/ 'newCN_24nm_line',  'BaseLine', 'BLof12nm', 'BLof24nm',
      'TempEnforcementLine', 'FishProtLine', 
      'TSmidLine', 'JCmidLine', 'KMlimLine',
      'TaiPingIslandLimLine','TJFishAggrement','TJFishAggrementSpecial'
  ];
  let tmpLayers=[gvar.grpBaseMaps]
  for (let i=0; i<gvar.layers4AuthUser.length; ++i){
    tmpLayers.push(gvar.Layers[gvar.layers4AuthUser[i]])
  }
  for (let i=0; i<gvar.layers4All.length; ++i){
    tmpLayers.push(gvar.Layers[gvar.layers4All[i]])
  }
  let map = new OlMap({
    layers: tmpLayers,
    /*layers: [gvar.grpBaseMaps, gvar.Layers.odbBasemap, 
      gvar.Layers.Himawari8, gvar.Layers.odb_temperature_30m,
      gvar.Layers.odb_current_20m, gvar.Layers.ECMWF,
      gvar.Layers.GeoName, gvar.Layers.Cplan, 
      gvar.Layers.CN_24nm_line, gvar.Layers.BaseLine, 
      gvar.Layers.BLof12nm, gvar.Layers.BLof24nm,
      gvar.Layers.EEZ, gvar.Layers.TempEnforcementLine,
      gvar.Layers.TSmidLine, gvar.Layers.JCmidLine, 
      gvar.Layers.KMlimLine, gvar.Layers.TaiPingIslandLimLine,],*/
    renderer: 'canvas',
    target: "map",
    view: new OlView({
      center: OlProjTransform([123.0, 23.851111],
        'EPSG:4326', 'EPSG:3857'),
      zoom: 7,
      minZoom: 1,
      maxZoom: 19
    }),
    //interactions: OlInteractionDefaults({
    //  zoomDelta: 5
    //}).extend([
    //  new OlMouseWheelZoom({ maxDelta:5, 
    //    MouseWheelZoomDelta:false})
    //]),
    //interactions: OlInteractionDefaults({
    //  zoomDelta:1,//gvar.zoomFactorDelta,
    //  zoomMaxDelta:5 // for mouse wheel zoom, added by cmd}
    //}),
    controls: OlControlDefaults({
      zoomOptions:{delta:gvar.zoomDelta}
    })/*.extend([
      new OlControlZoomSlider()
    ])*/
  });
  $('#map').data('map', map);
  //map.addLayer(gvar.Layers.LineOfLaw);
  map.addLayer(gvar.Layers.ShipTracks);
  map.getView().on('change:resolution', function() {
    gvar.Layers['GeoName'].setSource(
      new OlSourceVector({
        url:'/odbintl/rasters/tiledgeoname'+getMapZoom()+'.geojson',
      format: new OlFormatGeoJSON()
      })
    )
  });
  return map
}
function JSONVCUNDO(arg1){
  //console.log(arg1)
  var chgLog=gvar.cPlanVC.getChangeLog();
  var currentVer=gvar.cPlanVC.getVersion();
  var currentLog=currentVer-1;
  var moveToVer=currentVer-1;
  var currentOpt;
  var chkSwitchUndoRedoBtn=true
  if (arg1=='REDO'){
    if (currentVer==chgLog.length){
      // last version can not REDO
      return
    }
  }else{ // UNDO
    // zero version can not UNDO
    if (currentVer==0){
      return
    }
  }

  if (currentVer==0){
    currentOpt='empty'
    var redostep=2
  }else{
    if (chgLog[currentLog].path[1]=='length'){
      currentOpt='add'
      var undostep=-2
    }else if (! chgLog[currentLog].newValue){
      currentOpt='del'
      var undostep=-1
    }else{
      currentOpt='move'
      var undostep=-1
    }
  }
  var movestep=0
  var Opt='undefined'
  //console.log(arg1)
  if (arg1=='REDO'){
    if (chgLog[currentLog+1].path[0]=='line'){
      Opt='reLine'
      movestep=1
    }else if (chgLog[currentLog+1].opt=='delete_undo'){
      Opt='reDel'
      movestep=1
    }else if (chgLog[currentLog+1].opt=='block_undo'){
      Opt='rePtBlock'
      movestep=1
    }else if (chgLog[currentLog+2] && chgLog[currentLog+2].path[1]=='length'){
      Opt='reAdd'
      movestep=2
    }else{
      Opt='reMove'
      movestep=1
    }
  }else{ // UNDO
    if (chgLog[currentLog].path[0]=='line'){
      Opt='unLine'
      movestep=-1
    }else if (chgLog[currentLog].opt=='delete'){
      Opt='unDel'
      movestep=-1
    }else if (chgLog[currentLog].opt=='block'){
      Opt='unPtBlock'
      movestep=-1
    }else if (chgLog[currentLog].path[1]=='length'){
      Opt='unAdd'
      movestep=-2
    }else{
      Opt='unMove'
      movestep=-1
    }
  }
  //var moveToLog=currentLog+movestep
  var moveToVer=currentVer+movestep
  switch (Opt){
    case 'unMove':
      var oRec=gvar.cPlanVC.getChangeLog()[currentLog].oldValue
      var tmprow=$(`#StaTable tbody tr td:nth-child(1)`).filter(`:contains(${oRec[0]})`).parent()
      //1 lon, 2 lat, 3 site name
      tmprow.find('td').eq(1).find('div').html(Number(oRec[1]).toFixed(4)); 
      tmprow.find('td').eq(2).find('div').html(Number(oRec[2]).toFixed(4));
      tmprow.find('td').eq(3).find('div').text(oRec[3]);
      StaTblRow2Feature(oRec[0])
      if (ptInSchTable(oRec[0])){ 
        //沒進行版本控制，需要自動重製
        plotLineFromSchTable()
      }
      break;
    case 'unAdd':
      // remove the last added point
      var rec=gvar.cPlanVC.getChangeLog()[currentLog-1].newValue
      gvar.olpointsOverlay.getSource().removeFeature(gvar.olpointsOverlay.getSource().getFeatureById(rec[0]))
      var rowId=$(`#StaTable tbody tr td:nth-child(1)`).filter(`:contains(${rec[0]})`).parent().index()
      $(`#StaTable tbody tr`).eq(`${rowId}`).remove()
      if (rec[0]==gvar.autoID){
        gvar.autoID--
      }
      break;
    case 'unPtBlock':
      // remove the last added point
      var recs=gvar.cPlanVC.getChangeLog()[currentLog].newValue;
      var recs0=gvar.cPlanVC.getChangeLog()[currentLog].oldValue;
      var len0=recs0.length-1;
      chkSwitchUndoRedoBtn=false
      $("#undobtn").addClass("disabled")
      $("#redobtn").addClass("disabled")
      $("#undobtn").ready(function(){
        for (let i=1; i<recs0.length; i++){ //i=0 is head
          if (recs0[i]==-1){len0-=1}
        }
        for (let i=recs.length-1; i>len0; i--){ //
          rec=recs[i];
          gvar.olpointsOverlay.getSource().removeFeature(gvar.olpointsOverlay.getSource().getFeatureById(rec[0]))
          var rowId=$(`#StaTable tbody tr td:nth-child(1)`).filter(`:contains(${rec[0]})`).parent().index()
          $(`#StaTable tbody tr`).eq(`${rowId}`).remove()
          if (rec[0]==gvar.autoID){
            gvar.autoID--
          }
        }
        undoredoBtnSwitch(moveToVer,chgLog.length)
      })
      break;
    case 'unDel':
      // remove the last added point
      var rec=gvar.cPlanVC.getChangeLog()[currentLog].oldValue
      appendStaTable("StaTable",rec)
      AddPointFromRec(rec)
      break;
    case 'reMove':
      var oRec=gvar.cPlanVC.getChangeLog()[currentLog+movestep].newValue
      var tmprow=$(`#StaTable tbody tr td:nth-child(1)`).filter(`:contains(${oRec[0]})`).parent()
      //1 lon, 2 lat, 3 site name
      tmprow.find('td').eq(1).find('div').html(Number(oRec[1]).toFixed(4)); 
      tmprow.find('td').eq(2).find('div').html(Number(oRec[2]).toFixed(4));
      tmprow.find('td').eq(3).find('div').text(oRec[3]);
      StaTblRow2Feature(oRec[0])
      if (ptInSchTable(oRec[0])){ 
        //沒進行版本控制，需是自動重製
        plotLineFromSchTable();
      }
      break;
    case 'reAdd':
      var rec=gvar.cPlanVC.getChangeLog()[currentLog+movestep-1].newValue
      appendStaTable("StaTable",rec)
      AddPointFromRec(rec)
      if (rec[0]>gvar.autoID){
        gvar.autoID=rec[0]
      }
      break;
    case 'rePtBlock':
      var recs=gvar.cPlanVC.getChangeLog()[currentLog+movestep].newValue
      var recs0=gvar.cPlanVC.getChangeLog()[currentLog+movestep].oldValue;
      var len0=recs0.length;
      // 這個部份有可能比較花時間，所以boton disable掉之後
      // 要在ready之後才執行是否unable，而不是在最後面。
      chkSwitchUndoRedoBtn=false
      $("#undobtn").addClass("disabled")
      $("#redobtn").addClass("disabled")
      $("#redobtn").ready(function(){
        for (let i=1; i<recs0.length; i++){ //i=0 is head
          if (recs0[i]==-1){len0-=1}
        }
      //for (let i=1; i< recs.length; i++){ 
        for (let i=recs.length-1; i>len0-1; i--){ //
          rec=recs[i];
          appendStaTable("StaTable",recs[i],true);
          if (recs[i][0]>gvar.autoID){
            gvar.autoID=recs[i][0]
          }
        }
        for (let i=recs.length-1; i>len0-1; i--){ //
          AddPointFromRec(recs[i]);
        }
        undoredoBtnSwitch(moveToVer,chgLog.length)
      })
      break;
    case 'reDel':
      // remove the last added point
      var rec=gvar.cPlanVC.getChangeLog()[currentLog+movestep].oldValue
      gvar.olpointsOverlay.getSource().removeFeature(gvar.olpointsOverlay.getSource().getFeatureById(rec[0]))
      // remove data from statable
      var rowId=$(`#StaTable tbody tr td:nth-child(1)`).filter(`:contains(${rec[0]})`).parent().index()
      //if (rec[0]==gvar.autoID){
      //  gvar.autoID--
      //}
      $(`#StaTable tbody tr`).eq(`${rowId}`).remove()
      break;
    case 'unLine':
      var oRec=gvar.cPlanVC.getChangeLog()[currentLog].oldValue
      //console.log(currentLog)
      //console.log(oRec)
      iniSchTable();
      LnJSON2SchTable(oRec);
      break;
    case 'reLine':
      var oRec=gvar.cPlanVC.getChangeLog()[currentLog+movestep].newValue
      iniSchTable();
      LnJSON2SchTable(oRec);
      break;
    default:
      return
  }
  gvar.cPlanVC.gotoVersion(moveToVer);
  if (chkSwitchUndoRedoBtn){
    undoredoBtnSwitch(moveToVer,chgLog.length)
  }
  //JSON.stringify(gvar.cPlanJSON.points)
}
function undoredoBtnSwitch(movetoVer,verLength){

  if (movetoVer<=0){
    $("#undobtn").addClass("disabled")
  }else{
    $("#undobtn").removeClass("disabled")
  }
  if (movetoVer>=verLength){
    $("#redobtn").addClass("disabled")
  }else{
    $("#redobtn").removeClass("disabled")
  }
}
function JSONVC(){
  //console.log(JSON.stringify(gvar.cPlanJSON))
  //console.log(gvar.cPlanVC.getVersion())
}
function testJSONVC(){
  // sample data
  var obj = { list: [1, { p: 'hello' }, 3] };

  // Get versioning object for it
  var vc = new VersionControlled(obj);
  obj = vc.data; // we don't need the original anymore, this one looks the same

  // Demo of actions:
  //console.log(vc);
  //console.log(`v${vc.getVersion()} ${JSON.stringify(obj)}. Change text:`);
  obj.list[1].p = 'bye';
  //console.log(`v${vc.getVersion()} ${JSON.stringify(obj)}. Bookmark & add property:`);
  var bookmark = vc.getVersion();
  obj.list[1].q = ['added'];
  //console.log(`v${vc.getVersion()} ${JSON.stringify(obj)}. Push on list, then shift:`);
  obj.list.push(4); // changes both length and index '4' property => 2 version increments
  obj.list.shift(); // several changes and a deletion
  //console.log(`v${vc.getVersion()} ${JSON.stringify(obj)}. Go to bookmark:`);
  vc.gotoVersion(bookmark);

  //console.log(`v${vc.getVersion()} ${JSON.stringify(obj)}. Go to last version:`);
  vc.gotoLastVersion();
  //console.log(`v${vc.getVersion()} ${JSON.stringify(obj)}. Get change log:`);
  var changeLog = vc.getChangeLog();
  for (var chg of changeLog) {
      //console.log(JSON.stringify(chg));
  }

  //console.log('Restart from scratch, and apply the change log:');
  obj = { list: [1, { p: 'hello' }, 3] };
  vc = new VersionControlled(obj, changeLog);
  obj = vc.data;
  //console.log(`v${vc.getVersion()} ${JSON.stringify(obj)}`);
}

/*function setNewZoomFactor(zFactor){
  var newView = new ol.View({
    center: [0, 0],
    zoom: 2,
    zoomFactor:zFactor//just replace with your desired zoom factor value
  })
  map.setView(newView); 
}*/
function setHtmlInteraction(){
  $('#PlanList-a > a').click(function(){
    buildPlanList('cPlanList')
  })
  $('#LayerList-a > ul > li > .basemap').click(function(){
    changemap(this.id)
  })
  //$('#isolgraticuleSelected').click(function(){
  //  switchGraticule('olgraticule')
  //})
  $('#ChkLineMod').click(function(){
    switchToggle('schedule');
  })
  $('#setWorkItem').click(function(){
    switchToggle('schedule');
    chRightPanelSize();
  })
  $('#chkTableDragable').click(function(){
    setSchTableSortable('SchTable',this);
  })
  $('#export-png').on('click',function(){
    exportMap();
  });
  $('#export-table').on('click',function(){
    this.href=exportTable();
  });
  $('#submitLonLat').on('click',function(){
    textarea2StaTable();
  });
  //$('#gen_cr_app_pdf').on('click',function(){
  //  exportPDF();
  //});
  $('#genPdf > a').on('click',function(){
    chkSwitch();
    set_uploadmap_form();
  });
  $('#isTyphoonTracksSelected').on('click',function(){
    if ($('#isTyphoonTracksSelected').is(':checked')){
      $('#info2show').show()
    }else{
      $('#info2show').hide()
    }
  });
  $('#undobtn').click(function(){JSONVCUNDO('UNDO')})
  $('#redobtn').click(function(){JSONVCUNDO('REDO')})
  $('#erasebtn').click(function(){$("#resetConfirmModal").modal('show')})
  $('#resetAllDataBtn').click(function(){resetAll()})
  $('.modal.draggable>.modal-dialog').draggable({
    cursor: 'move',
    handle: '.modal-header'
  });
  $('.modal.draggable>.modal-dialog>.modal-content>.modal-header').css('cursor', 'move');
  $('#btn_collapse_cr_app').click(function(){
    $(this).text(function(i,old){
        //return old=='展開航次申請表' ?  '收合航次申請表' : '展開航次申請表';
        return $("#cruise_info_div").attr("aria-expanded")=="true" ?  '展開航次申請表' : '收合航次申請表';
    });
  });
  }
function setMapModalInteraction(mapobj){
  /* mapModal Interaction*/
  $('#mapModal .modal-dialog').draggable();
  $('#mapModal').on('hidden.bs.modal', function(){
    mapobj.setTarget('map');
    gvar.oldrawcplan.setActive(!document.getElementById("ChkLineMod").checked)
    changeMapSize('map','fullfill');
    gvar.chkMapModify=true;
  });
  $('#mapModal').on('shown.bs.modal', function(){
    mapobj.setTarget('map2');
    $('#map2').data('map',mapobj);
    gvar.chkMapModify=false;
  });
  $('#mapModal').find('.chMapShape').on('click',function(){
    changeMapSize('map2',this.dataset.shape);
  })

  $('#mapModal').find('.btn4getMapFig').on('click',function(){
    rdCanvas2ImgArr();
  })

  $('#pdfFormModal').on('click',function(){
    chkSwitch();
    //set_uploadmap_form();
  });
  $('#pdfFormModal').on('shown.bs.modal',function(){
    if ($('#ShipborneEquipmentsModal').data('rv') != $('#shipSelect').val()){
      let or1_shipborne=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,
                    16,17,18,19,20,21,29,22,23,24,25,26,27,28]
      buildChkList('ShipborneEquipmentList',or1_shipborne);
      $('#ShipborneEquipmentsModal').data('rv', $('#shipSelect').val())
    }
    //console.log('Now to detect collapse or not: ', gvar.cPlanInfo.enter_sensitive_sea_areas, $('#form_sensea').hasClass('in'))
    if (gvar.cPlanInfo.enter_sensitive_sea_areas) { //&& $('#form_sensea').hasClass('in')) {
        $('#form_sensea').collapse('show');
    }
  });
  $('#pdfFormModal').find('.btn4uploadMap').on('click',function(){
    let plannameObj=$("#PlanName"); //modified by cywhale 202107, the same code in submitTable, but if not check (should save first), no plan_name in mode cause django error
    let planname=plannameObj.val();
    if (planname==null || planname==""){
      alert('儲存名稱未輸入，並請儲存');
      return
    } else if (planname.includes(";")||planname.includes("#") || planname.includes("|")){
        alert('儲存名稱不可包含 | # ;');
        return
    } else {
      submitTable(); uploadMap();
    }
  })
  $('#CPlanSelectionModal').on('show.bs.modal', function(){
    $('#isCplanSelected')[0].checked=true; 
    switchLayer('Cplan');
    buildCplanLayerList();
  });
  $('#ShipborneEquipmentsModal').on('show.bs.modal', function(){
    if ($('#ShipborneEquipmentsModal').data('rv') != $('#shipSelect').val()){
      let or1_shipborne=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,
                    16,17,18,19,20,21,29,22,23,24,25,26,27,28]
      buildChkList('ShipborneEquipmentList',or1_shipborne);
      $('#ShipborneEquipmentsModal').data('rv', $('#shipSelect').val())
    }
  });

  $('#ShipborneEquipmentsModal').on('hidden.bs.modal', function(){
    //collectShipborneEquips()
    /*gvar.cPlanInfo.shipborne={}
    let tmpobjs=$('[id*=ShipborneEquipmentList_]')
    tmpobjs.each(function (index){
      let equipId=$(this).prop('id').replace("ShipborneEquipmentList_","");
      gvar.equipments[equipId][1]=$(this).prop('checked')
      gvar.cPlanInfo.shipborne[equipId]=gvar.equipments[equipId]
    })*/
  });

  $('#CPlanSelectionModal #cplanSelInverse').on('click',function(){
    $('#CPlanLayerList input').click();
  });
  $('#CPlanSelectionModal #cplanSelAll').on('click', function(){
    $('#CPlanLayerList input:not(:checked)').click();
  });
}
function setTableInteraction(){
  //$("#SchTable > tbody > tr > td").on('focus',  function() {
  $("#SchTable").on('click','tr > td',  function() {
    var $this = $(this);
    $this.data('before', $this.text());
  })
  $("#SchTable").on('blur paste','tr > td', function() {
    var $this = $(this);
    if ($this.data('before') !== $this.text()) {
      $.when(plotLineFromSchTable()).then(function(){
        gvar.cPlanJSON.line=gvar.SchData.line;
      });
      //plotLineFromSchTable();
      //gvar.cPlanJSON.line=gvar.SchData.line
      $this.data('before', $this.text());
    };
  }).on('keydown','tr > td',function(e){
    var $this = $(this);
    if (e.keyCode == 13) {
      if ($this.data('before') !== $this.text()) {
        $.when(plotLineFromSchTable()).then(function(){
          gvar.cPlanJSON.line=gvar.SchData.line;
        });
        //plotLineFromSchTable();
        //gvar.cPlanJSON.line=gvar.SchData.line
        $this.data('before', $this.text());
      };
      let nextRow=$this.closest('tr').next();
      if ($this.closest('tr').next().length>0){
        $this.closest('tr').next().eq(0).find('td').eq([$this[0].cellIndex]).find('div').click()
      }
      return false;
    };
  });
  // 關於 work item 資料的變動記錄由saveWkItem處理
  var $TABLE = $('#SchTableDiv');
  $('.table-add').click(function () {
    var $clone = $TABLE.find('tr.hide').clone(true).removeClass('hide table-line');
    $TABLE.find('table').append($clone);
  });
  $('.table-remove').click(function () {
    $(this).parents('tr').detach();
    //console.log('abc')
    $.when(plotLineFromSchTable()).then(function(){
      gvar.cPlanJSON.line=gvar.SchData.line;
    });
    //plotLineFromSchTable()
    //gvar.cPlanJSON.line=gvar.SchData.line
  });
  $('.table-up').click(function () {
    var $row = $(this).parents('tr');
    if ($row.index() === 1) return; // Don't go above the header
    $row.prev().before($row.get(0));
    //console.log('abc')
    plotLineFromSchTable()
    gvar.cPlanJSON.line=gvar.SchData.line
  });
  $('.table-down').click(function () {
    var $row = $(this).parents('tr');
    $row.next().after($row.get(0));
    //console.log('abc')
    plotLineFromSchTable()
    gvar.cPlanJSON.line=gvar.SchData.line
  });

}
function JoyrideInfo(){
  var FormChkAutoLineTip={
    'objId':'FormChkAutoLine',
    'placement':'bottom',
    'html':'true',
    'title':'自動連接路徑開關',
    'content':"勾選此開關後，使用者於地圖上所新增站位，系統會自動將新增的站位增加至航程規畫表中。現在請您勾選自動連接路徑開關後於地圖中再新增三個點。"
  };

  var DivStaTableTip={
    'objId':'DivStaTable',
    'placement':'bottom',
    'html':'true',
    'title':'站點資訊表格',
    'content':"使用者於地圖上所新增站位(滑鼠左鍵)，系統會自動將新增的站位增加至航程規表中。現在請先試著在地圖上任意點三個點。<br>完成之後，此處應該會出現一張有著(ID, Longitude, Latitude, Name )等欄位的表格，其中除了ID是不可編輯(灰色字)外，其餘欄位均可編輯。<img src='/odbintl/static/cmd/cplan_guide/ug01.png' width='100%'></img>經、緯度的欄位除了以度為單位輸入外，亦接受DDD MM.M 的格式，例如121度25.5分，您可以輸入121d25.50或121d25m30(意即輸入121度25分30秒)，系統會自動將其轉成121.425度。同樣在批次座標處理也可支援此格式。<br><i class='fa fa-check'></i> 點擊ID數字，地圖會移動到以該站位為中心點。<br><i class='fa fa-check'></i>滑鼠移至地圖的站點後，鼠標變成<i class='fa fa-arrows'></i>，此時按住滑鼠左鍵不放，可以將站點拖曳至新點位。<br><i class='fa fa-check'></i>勾選 Name 旁邊的方框，則地圖上站點顯示的文字為站名，取消勾選則顯示ID。<br><i class='fa fa-check'></i> 點擊表格中最後一欄的紅色X記號後將刪除該點於地圖及Sites表中該點資訊。當某點位被規畫進航程表中時，紅色X記號不會出現，表示無法刪除該站點。"
  };

  var FormChkLineTip={
    'objId':'FormChkLineMod',
    'placement':'bottom',
    'html':'true',
    'title':'路徑規畫、工作規劃、表格拖曳開關',
    'content':"勾選「路徑規畫模式」開關後，此時地圖進入路徑規畫模式。此模式下，地圖無法透過滑鼠左鍵新增站位，但當使用者將滑鼠移至現有站位上方後，鼠標變成<i class='fa fa-hand-pointer-o'></i>，此時按下滑鼠左鍵，會自動將此點位新增至航程規表中。<br><i class='fa fa-check'></i> 此模式下地圖無法新增站位，將此模式打開是避免誤觸地圖而新增站位的妙招。<br><i class='fa fa-check'></i>勾選 工作規劃 表格將增加一欄，可供您設定工作項目。<br><i class='fa fa-check'></i>勾選 表格拖曳 您將可透過拖曳的方式，變動站點造訪順序。<br><i class='fa fa-check'></i>輸入船速，系統會計算航時；輸入航時則會計算船速。但請務必注意船速/航時是否超出預期太多。後續製作航次報表時即根據。"
  }

  var SavePlanTip={
    'objId':'PlanName',
    'placement':'bottom',
    'html':'true',
    'title':'儲存規畫結果',
    'content':"您可以隨時將您的規畫結果儲存，在您按下「儲存」之前，必需在此處輸入存檔名稱。"
  }

  var LayerListTip={
    'objId':'LayerList',
    'placement':'bottom',
    'html':'true',
    'title':'Basemap 下拉式選單',
    'content':"請您先點開此圖層下拉式選單，以便得到如下圖之選單。此選單分為底層區與圖層區二個區塊。底圖區的圖層勾選是直接置換最底層的地圖；圖層區則是在疊加勾選的圖層(可以多圖層套疊)<br><img class='float-left' src='/odbintl/static/cmd/cplan_guide/ug02.png' width='80%'></img><br>"
  }
  var PlanListTip={
    'objId':'PlanList-a',
    'placement':'bottom',
    'html':'true',
    'title':'載入已儲存資料 下拉式選單',
    'content':"透過此選單可載入您曾經儲存過的規畫資料，如下圖所示。<br><img class='float-left' src='/odbintl/static/cmd/cplan_guide/ug03.png' width='90%'></img><br>"
  }
  var genPdfTip={
    'objId':'genPdf',
    'placement':'bottom',
    'html':'true',
    'title':'產生規劃表',
    'content':"透過此選單可產生航次規劃報表PDF檔。規劃報表內容根據您所輸入的航次規劃，可自動產製航程作業大網表(預計抵達時間、離開時間及作業項目)，以及站點座標表與位置圖(可自訂全域圖及區域放大圖)。<br><img class='float-left' src='/odbintl/static/cmd/cplan_guide/ug04.png' width='90%'></img><br>"
  }
  var DataIOTip={
    'objId':'DataIO-li',
    'placement':'bottom',
    'html':'true',
    'title':'DataIO 下拉式選單',
    'content':"請您先點開此圖層下拉式選單，以便得到如下圖之選單。<br><img class='float-left' src='/odbintl/static/cmd/cplan_guide/ug05.png' width='90%'></img><br><i class='fa fa-check'></i>匯出地圖是讓您將目前的航次規畫圖層下載成為png圖檔。<br><i class='fa fa-check'></i>產生規劃表 則是讓您可以將目前的航次規劃結果製作成航次規劃報表PDF檔。<br><i class='fa fa-check'></i>匯出表格：將Sites與Schedule二個表格存成CSV檔。(如果您忘記登入帳號，可暫時將站點表匯出)。<br><i class='fa fa-check'></i>批次座標處理：可供您直接將一系列的經緯度坐標值貼上，免去一個點一個點輸入的困擾，下圖所示即為一個操作範例。<br><img class='float-left' src='/odbintl/static/cmd/cplan_guide/ug06.png' width='90%'></img>"
  }


  buildJoyride([DivStaTableTip, FormChkAutoLineTip,  FormChkLineTip, SavePlanTip,PlanListTip, genPdfTip, DataIOTip, LayerListTip]);

  
}
function buildJoyride(tipContents){
  var tipContentsLen=tipContents.length;
  for (var tmpi=tipContents.length-1; tmpi>0; tmpi--){
   //this loop make sure the last tip is not hide (if hide, make the list shorter, because we
   //  need to insert "end" in the last tip. ) 
    var tipContent=tipContents[tmpi];
    var obj=document.getElementById(tipContent.objId);
    if (!obj){
      tipContents.splice(tmpi,1)
    }
  }
  tipContentsLen=tipContents.length;
  for (var tmpi=0; tmpi< tipContentsLen; tmpi+=1){
    var tipContent=tipContents[tmpi];
    var obj=document.getElementById(tipContent.objId);
    if (obj){
      obj.setAttribute("data-toogle","popover");
      obj.setAttribute("data-placement",tipContent.placement);
      obj.setAttribute("data-trigger","manual");
      obj.setAttribute("data-boundary","window");
      obj.setAttribute("data-html",tipContent.html);
      obj.setAttribute("title",tipContent.title+"<a href='#' class='close' data-dismiss='alert'>&times;</a>");
      var tmpContent=tipContent.content
      if (tmpi>0){
        tmpContent+="<a href='#' data-dismiss='alert' class='prev' onClick=$('#"+tipContents[tmpi-1].objId+"').popover('show');>prev</a>； ";
      }
      if (tmpi<tipContentsLen-1){
        tmpContent+="<a href='#' data-dismiss='alert' class='next' onClick=$('#"+tipContents[tmpi+1].objId+"').popover('show');>next</a>";
      }
      if (tmpi==tipContentsLen-1){
        tmpContent+="<a href='#' data-dismiss='alert' class='end' onClick=$('#"+tipContents[tmpi].objId+"').popover('hide');>end</a>";
      }
      obj.setAttribute("data-content",tmpContent);
      $('#'+tipContent.objId).popover();
    }
  }
  $(document).on("click", ".popover .close" , function(){
    $(this).parents(".popover").popover('hide');
  });
  $(document).on("click", ".popover .next" , function(){
    $(this).parents(".popover").popover('hide');
  });
  $(document).on("click", ".popover .prev" , function(){
    $(this).parents(".popover").popover('hide');
  });
}
function iniLayers(){
  let staticUrl='/odbintl/static/'
  let Layers={};
  let nmap=$('#map').data('map');
  Layers.odbBasemap = new OlLayerTile({
    name: 'odbBasemap',
    desc_cn:"ODB水深(圖層)",
    visible: false,
    source: new OlSourceXYZ({
      //url: '../tiles/Tai_02/{z}/{x}/{y}.tif'
      url: '/odbintl/rasters/tiles/odb_dep/{z}/{x}/{y}.tif'
    })
  });
  /*Layers.odbBasemap = new OlLayerImage({ 
    name: 'odbBasemap',
    opacity:0.5,
    desc_cn:"ODB水深(圖層)",
    visible: false,
    source: new OlSourceImageWMS({
      url: '/odbintl/rasters/odbwms/',
      params: {'LAYERS': 'odb_deppac','VERSION':'1.1.1'},
      ratio: 1
    }),
  });*/

  Layers.odb_temperature_30m = new OlLayerTile({
    name: 'odb_temperature_30m',
    desc_cn:"ODB水深30m溫度平均場",
    visible: false,
    source: new OlSourceXYZ({
      url: '/odbintl/rasters/tiles/odb_temperature_30m_600dpi/{z}/{x}/{y}.tif'
    })
  });
  Layers.odb_current_20m = new OlLayerTile({
    name: 'odb_current_20m',
    desc_cn:"ODB水深20m平均流場",
    visible: false,
    source: new OlSourceXYZ({
      url: '/odbintl/rasters/tiles/odb_current_20m/{z}/{x}/{y}.tif'
    })
  });
  //var Himawari8Source=new OlSourceXYZ({url:'../himawari/{z}/{x}/{y}.tif'});
  var latTxtStyle=new OlStyleText({
    font: '18px Calibri,sans-serif',
    textAlign:'end',
    fill: new OlStyleFill({
      color:'rgba(125,125,125,1)'
    }),
    stroke: new OlStyleStroke({
      color:'rgba(255,255,255,1)',
      width:3
    })
  });
  var lonTxtStyle=new OlStyleText({
    font: '18px Calibri,sans-serif',
    textBaseline:'bottom',
    fill: new OlStyleFill({
      color:'rgba(125,125,125,1)'
    }),
    stroke: new OlStyleStroke({
      color:'rgba(255,255,255,1)',
      width:3
    })
  });
  Layers.olgraticule = new  OlGraticule({
    // the style to use for the lines, optional.
    name:'olgraticule',
    //className:'olgraticule',
    desc_cn:"經緯線",
    visible: false,
    strokeStyle: new OlStyleStroke({
      color: 'rgba(255,120,0,0.9)',
      width: 1
    }),
    targetSize: 200,
    lonLabelStyle: lonTxtStyle,
    latLabelStyle: latTxtStyle,
    showLabels: true
  });
  Layers.Himawari8 = new OlLayerTile({
    name: 'Himawari8',
    desc_cn:"紅外線雲圖",
    visible: false,
    source: new OlSourceXYZ({url:'/odbintl/rasters/himawari/{z}/{x}/{y}.tif'})
    //source: new OlSourceXYZ({
    //  //url: '../himawari/{z}/{x}/{y}.tif?TIME=2016-11-23T17:00:00Z'
    //  url: '../himawari/{z}/{x}/{y}.tif'
    //})
  });
  Layers.ECMWF = new OlLayerImage({
    name:'ECMWF',
    desc_cn:"ECMWF3小時預報風場",
    zIndex:1,
    visible:false,
    source: new OlSourceImageStatic({
      //url:"http://odbgo.oc.ntu.edu.tw/odbargo/static/figs/ecmwf/windlatest.png"+
      url:"https://odbpo.oc.ntu.edu.tw/static/figs/ecmwf/windlatest.png"+
      "?time="+(new Date()).getTime(),
      projection:'EPSG:4326',
      imageExtent:[105,2,135,35],crossOrigin:'anonymous'})
  });
  Layers.GeoName = new OlLayerVector({
    name: 'GeoName',
    desc_cn:"GeoName",
    visible: false,
    source: new OlSourceVector({
      url: '/odbintl/rasters/tiledgeoname'+getMapZoom()+'.geojson',
      format: new OlFormatGeoJSON()
    }),
   style: textstylefunction
  });

  Layers.Cplan = new OlLayerVector({
    name:'Cplan',
    desc_cn:"歷史cPlan",
    visible:true,
    source: new OlSourceVector({
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(225,225,225,0.75)',
        width: 2
      }),
      image: new OlStyleCircle({
        radius: 3,
        fill: new OlStyleFill({
          color: 'rgba(225,225,225,0.75)'
        })
      })
    })
  })
  Layers=createLineOfLawLayer(Layers,staticUrl);
  Layers.ShipTracks=createShipTrackLayer();
  return Layers;
}
export async function redrawSubImgs(n){
  if (n===undefined){ // Note: redrawSubImgs is a recursive function with n=0, 1, iterately
    n=0;
  }
  var imgs4pdfObj=document.getElementById('imgs4pdf');
  if (gvar.cPlanInfo.SubImgsInfo){
    let oImgs=JSON.parse(gvar.cPlanInfo.SubImgsInfo) //'[{key:val, k2:val2, ..}, {}, {}]'
    let omapsize=gvar.map.getSize();
    let a4needx = [];
    for (let jt in oImgs) {
      let jx = parseInt(jt); //it's "0", "1", "2",...
      if (oImgs[jx].hasOwnProperty('a4need')) {
         a4needx.push(oImgs[jx].a4need);
      } else {
         a4needx.push(false);
      }
    }

    if (n < oImgs.length){
      $('#pdfFormModal .modal-footer .btn4uploadMap').attr('disabled','disabled')
      if (gvar.imgMapArr[n]){
        $('#pdfFormModal .modal-footer .btn4uploadMap').removeAttr('disabled')
        //console.log('abc');
      }else{
        //console.log(['a',n])
        gvar.imgMapArr.push(new Image());
        let tmpimg=new Image();
        await sleep(500)
        gvar.imgMapArr[n].setAttribute("data-mapSize",oImgs[n].size);
        gvar.tmpNr+=1;
        gvar.imgMapArr[n].setAttribute("id","img_"+gvar.tmpNr);
        gvar.imgMapArr[n].setAttribute("data-mapSize",oImgs[n].size);
        gvar.imgMapArr[n].setAttribute("data-mapExtent",oImgs[n].extent);
        gvar.imgMapArr[n].setAttribute("class","img-thumbnail");
        gvar.imgMapArr[n].a4need= a4needx[n]; //A4-need

        //gvar.imgMapArr[n].setAttribute("onclick","javascript:gvar.updateImgArrIdx="+n.toString()+";gfun.changeMapSize('map','"+oImgs[n].size+"','"+oImgs[n].extent+"');$('#mapModal').modal();gfun.changeMapSize('map2','"+oImgs[n].size+"')");
        ////gvar.imgMapArr[n].setAttribute("onclick","javascript:gvar.updateImgArrIdx="+n.toString()+";gfun.changeMapSize('map','"+oImgs[n].size+"','"+oImgs[n].extent+"');$('#mapModal').modal();gfun.changeMapSize('map2','"+oImgs[n].size+"')");
        //changeMapSize('map',oImgs[n].size,oImgs[n].extent);
        //更改地圖大小跟縮放分二步，不然有煩人的異步問題。
        changeMapSize('map',oImgs[n].size);
        let tmpextent=oImgs[n].extent.split(',');
        await sleep(200)
        gvar.map.getView().fit(tmpextent);
        gvar.map.once('rendercomplete',function(){
          //console.log('abdc');
          //let dataURL=$('canvas').get(0).toDataURL("image/png");
          let dataURL=Map2DataUrl();
            gvar.imgMapArr[n].src=dataURL;
            imgs4pdfObj.appendChild(gvar.imgMapArr[n]);
            return redrawSubImgs(n+1);
        })
        await sleep(100)
        let wh=oImgs[n].size.split(",");
        gvar.imgMapArr[n].width=parseInt(wh[0]/700*200);
        gvar.imgMapArr[n].height=parseInt(wh[1]/700*200);
      }
    }else{
      //for ie 11 ...
      $('#pdfFormModal .modal-footer .btn4uploadMap').removeAttr('disabled')
      if (n>0){
        for (let i=0; i<n; i++){
          let wh=oImgs[i].size.split(",");
          $('#imgs4pdf > img').get(i).width=parseInt(wh[0]/700*200)
          $('#imgs4pdf > img').get(i).height=parseInt(wh[0]/700*200)
          await sleep(150);
        }
        changeMapSize('map','fullfill');
        let a='<span class="closebtn" style="cursor:pointer">&times;</span>';
        $('#imgs4pdf > img').after(a);

        //let ix=0 //not insert
        for (let i=0; i<n; i++){
          //A4-need
          if ($('#imgs4pdf > img').get(i).a4need) {
            let b='<span class="a4needico glyphicon glyphicon-resize-full" style="font-size:16px;cursor:pointer;margin-left:-20px;margin-right:5px;color:red;" '+
                  'data-toggle="tooltip" data-placement="top" title="Generate A4-size image in PDF 製作PDF時產生此A4-size圖檔"></span>';
            $('#imgs4pdf > img').eq(i).after(b); //.eq return jquery obj, but .get return DOM
            //ix = ix + 1;
          }
        }
      }
      setCloseBtnInteraction();
      setSubImgClick();
    }
  }
  //changeMapSize('map','fullfill');
}
function setSubImgClick(){
  $("#imgs4pdf > img").off( "click" );
  $('#imgs4pdf > img').click(function(){
    let fidx=$(this).attr('id');
      //console.log('[fidx,gvar.imgMapArr[j].id]')
    for (let j=0;j<gvar.imgMapArr.length;j++){
      //console.log([fidx,gvar.imgMapArr[j].id])
      if (gvar.imgMapArr[j].id==fidx){
        //console.log(this.getAttribute('data-mapextent'));
        let a=this.getAttribute('data-mapextent');
        let b=this.getAttribute('data-mapsize');
        changeMapSize('map',b,a);
        $('#mapModal').modal();
        changeMapSize('map2',b);
        gvar.updateImgArrIdx=j;
      }
    }
  })
}
function setCloseBtnInteraction(){
  $(".closebtn").off( "click" );
  $(".closebtn").click(function () {
    let with_a4need = $(this).prev().hasClass("a4needico");
    let fidx=with_a4need? $(this).prev().prev("img").attr('id') : $(this).prev("img").attr('id'); //modified by cywhale because A4-need insert between img and closebtn, add another .prev()
    let tmpidx=fidx.replace('img_','');

    if (with_a4need) {
        $(this).prev("#a4needico"+tmpidx).remove(); //A4-need
    }

    for (let j=0;j<gvar.imgMapArr.length;j++){
      //console.log([fidx,gvar.imgMapArr[j].id])
      if (gvar.imgMapArr[j].id==fidx){
        gvar.imgMapArr.splice(tmpidx,1);
      }
    }
    //console.log($(this).prev("img").attr('id'));
    $(this).prev("img").remove();
    $(this).remove();
  });
}
function getMapZoom(nmap){
  nmap=$('#map').data('map');
  let tmpZoom=7; /*default map zoom was 7*/
  if (nmap!=undefined){
    //tmpZoom=Math.floor(nmap.getView().getZoom()/gvar.zoomFactorDelta)
    tmpZoom=Math.floor(nmap.getView().getZoom())
  }
  return tmpZoom
}
function set_sidebar_interaction() {
  $('.sidebar-left .slide-submenu').on('click',function() {
    var thisEl = $(this);
    thisEl.closest('.sidebar-body').fadeOut('slide',function(){
      $('.mini-submenu-left').fadeIn();
        applyMargins();
    });
  });
  $('.mini-submenu-left').on('click',function() {
    var thisEl = $(this);
    $('.sidebar-left .sidebar-body').toggle('slide');
    thisEl.hide();
    applyMargins();
  });

  $('.sidebar-right .slide-submenu').on('click',function() {
    var thisEl = $(this);
    thisEl.closest('.sidebar-body').fadeOut('slide',function(){
      $('.mini-submenu-right').fadeIn();
      applyMargins();
    });
  });

  $('.mini-submenu-right').on('click',function() {
    var thisEl = $(this);
    $('.sidebar-right .sidebar-body').toggle('slide');
    thisEl.hide();
    applyMargins();
  });
  $(window).on("resize", applyMargins);
}
function applyMargins() {
  var leftToggler = $(".mini-submenu-left");
  var rightToggler = $(".mini-submenu-right");
  if (leftToggler.is(":visible")) {
    $("#map .ol-zoom")
      .css("margin-left", 0)
      .removeClass("zoom-top-opened-sidebar")
      .addClass("zoom-top-collapsed");
  } else {
    $("#map .ol-zoom")
      .css("margin-left", $(".sidebar-left").width())
      .removeClass("zoom-top-opened-sidebar")
      .removeClass("zoom-top-collapsed");
  }
  if (rightToggler.is(":visible")) {
    $("#map .ol-rotate")
      .css("margin-right", 0)
      .removeClass("zoom-top-opened-sidebar")
      .addClass("zoom-top-collapsed");
  } else {
      $("#map .ol-rotate")
        .css("margin-right", $(".sidebar-right").width())
        .removeClass("zoom-top-opened-sidebar")
        .removeClass("zoom-top-collapsed");
  }
}

function isConstrained() {
  return $("div.mid").width() == $(window).width();
}

function applyInitialUIState() {
  if (isConstrained()) {
    $(".sidebar-left .sidebar-body").fadeOut('slide');
    $(".sidebar-right .sidebar-body").fadeOut('slide');
    $('.mini-submenu-left').fadeIn();
    $('.mini-submenu-right').fadeIn();
  }
}
function CSVToArray( strData, strDelimiter ){
  // Check to see if the delimiter is defined. If not,
  // then default to comma.
  strDelimiter = (strDelimiter || ",");
  // Create a regular expression to parse the CSV values.
  var objPattern = new RegExp((
    // Delimiters.
   "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
    // Quoted fields.
   "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
   // Standard fields.
   "([^\"\\" + strDelimiter + "\\r\\n]*))"
  ),"gi");
  // Create an array to hold our data. Give the array
  // a default empty first row.
  var arrData = [[]];
  // Create an array to hold our individual pattern
  // matching groups.
  var arrMatches = null;
  while (arrMatches = objPattern.exec( strData )){
    // Get the delimiter that was found.
    var strMatchedDelimiter = arrMatches[ 1 ];
    // Check to see if the given delimiter has a length
    // (is not the start of string) and if it matches
    // field delimiter. If id does not, then we know
    // that this delimiter is a row delimiter.
    if (strMatchedDelimiter.length && (strMatchedDelimiter != strDelimiter)){
      // Since we have reached a new row of data,
      // add an empty row to our data array.
      arrData.push( [] );
    }
    // Now that we have our delimiter out of the way,
    // let's check to see which kind of value we
    // captured (quoted or unquoted).
    if (arrMatches[ 2 ]){
      // We found a quoted value. When we capture
      // this value, unescape any double quotes.
      var strMatchedValue = arrMatches[ 2 ].replace(
        new RegExp( "\"\"", "g" ),
        "\""
        );
    } else {
      // We found a non-quoted value.
      var strMatchedValue = arrMatches[ 3 ];
    }
    // Now that we have our value string, let's add
    // it to the data array.
    arrData[ arrData.length - 1 ].push( strMatchedValue );
  }
  // Return the parsed data.
  return( arrData );
}

function textarea2StaTable(){
  var lonlatStrObj=$('#lonlatCSV');
  var dataCoordObj=document.getElementById('inputdata_coordsystem');
  var dataCoord=dataCoordObj.options[dataCoordObj.selectedIndex].value;
  //console.log(dataCoord);
  //var lonlatStr=lonlatStrObj.val();
  let lonlat;
  let tmplon;
  let tmplat;
  if (lonlatStrObj.val()){
    lonlat=CSVToArray(lonlatStrObj.val());
  }else{
    lonlat=null;
  };
  if (lonlat[0].length < 2) {
    lonlat=CSVToArray(lonlatStrObj.val(),"\t");
  };
  if (lonlat[0].length < 2) {
    lonlat=CSVToArray(lonlatStrObj.val(),"\ ");
  };
  //console.log("debug LonLat", lonlat);
  var pointsSource=gvar.olpointsOverlay.getSource()
  gvar.points = pointsSource.getFeatures();
  let startID=gvar.autoID+1; //start ID for lonlatCSV
  var tmpname=''
  var totRecs=0
  var chkInline=$('#ChkLineGen').is(":checked")
  var inLine=Number(!chkInline)
  var tmprec=[]
  let tlon, tlat;
  for ( let tmpidx in lonlat ){
    tmpname=''
    gvar.autoID+=1;
    totRecs+=1;
    tmplon=NaN;
    tmplat=NaN;
    //20211122 cywhale added, let batch upload longlat can also use Degree/Min/Sec <- 121d50m22.30, 25d5m51.82 format
    if (/[d]/g.test(lonlat[tmpidx][0])) {
      tlon = convertGPS(lonlat[tmpidx][0]);
    } else {
      tlon = lonlat[tmpidx][0];
    }
    if (/[d]/g.test(lonlat[tmpidx][1])) {
      tlat = convertGPS(lonlat[tmpidx][1]);
    } else {
      tlat = lonlat[tmpidx][1];
    }
    //console.log("convert Longlat", tlon, tlat);
    if (lonlat[tmpidx].length == 2) {
      tmplon=parseFloat(tlon);
      tmplat=parseFloat(tlat);
      tmpname='site'+gvar.autoID.toString()
    }else if (lonlat[tmpidx].length == 3) {
      tmplon=parseFloat(tlon);
      tmplat=parseFloat(tlat);
      tmpname=lonlat[tmpidx][2];
    }
    //console.log("Then calculate:", tmplon, tmplat);
    if (! isNaN(tmplon) || ! isNaN(tmplat)){
      var newpoint= new OlFeature({
        geometry: new OlGeomPoint(OlProjTransform([tmplon,tmplat],dataCoord,'EPSG:3857')),
        'id': gvar.autoID,
        'name': tmpname,
        'inLine':inLine,
      });
      newpoint.setId(gvar.autoID);
      pointsSource.addFeature(newpoint);
      //tmprec.push([gvar.autoID, tmplon, tmplat, tmpname, inLine])
    }else{
      gvar.autoID-=1;
      totRecs-=1;
      console.log(lonlat[tmpidx]+' 格式不對，程式將忽略!')
    }
  };
 /*
  if ($('#StaTable > tbody').length==0){
    iniStaTable();
  }
  for ( let tmpi=0; tmpi<tmprec.length; tmpi+=1 ){
    appendStaTable("StaTable",tmprec[tmpi])
  }
  gvar.cPlanJSON.points.push(tmprec); //1220
 */
  tmprec=[gvar.StaData.ptHead];
  //tmprec=[];
  iniStaTable();
  for (let tmpi=0; tmpi<gvar.points.length;tmpi+=1){
    tmprec.push(Feature2StaTblRow(false, gvar.points[tmpi], gvar.points[tmpi].getId()))
  }
  gvar.cPlanJSON.points=tmprec;
  plotPointFromStaTable();
  //if (document.getElementById("ChkLineGen").checked){
  if (chkInline){
    for ( let tmpidx=0; tmpidx<totRecs; tmpidx+=1 ){
      SchTableAddRow(startID+parseInt(tmpidx));
    };  
    $.when(plotLineFromSchTable()).then(function(){
      gvar.cPlanJSON.line=gvar.SchData.line;
    });
    //plotLineFromSchTable();
    //gvar.cPlanJSON.line=gvar.SchData.line
  };
}
function buildPlanList(ulId) {
  var ulObj=document.getElementById(ulId);
  while (ulObj.firstChild){
    ulObj.removeChild(ulObj.firstChild);
  }
  let $ulObj=$(ulObj);
  $.getJSON('/odbintl/rasters/getcPlanList/', function(data) {

    for (let tmpi=0; tmpi<data.length; tmpi++){
      let tmpli=$('<li></li>')
      let tmpdiv= $('<div class="inline"></div>');
      let tmpa1=$('<a><i class="fa fa-file-text"></i>'+data[tmpi].fields.name+'</a>')
      tmpa1.click(function(){
        loadPlan(data[tmpi].fields.name)
      });
      let tmpspan=$('<span class="pull-right"></span>');
      let tmpstr = '<a href="./exportcplan/'+data[tmpi].pk+'?datatype=kml"><i class="fa fa-download"></i></a> '
      tmpstr += '<a data-toggle="modal" data-target="#iFrameModal" data-pk="'+data[tmpi].pk+'" style="margin:5px;"><i class="fa fa-trash-alt"></i></a>'
      let tmpa2=$(tmpstr);
      tmpspan.append(tmpa2);
      tmpdiv.append(tmpa1,tmpspan);
      tmpli.append(tmpdiv);
      $ulObj.append(tmpli)
    }
    $ulObj.find('span > a:last-child').click(function(){
      document.getElementById('iFrame1').src='/odbintl/rasters/deletecplan/'+this.dataset.pk
    })
  });
}
async function AddPointFromRec(rec){
  new Promise(function(){
  var pointsSource=gvar.olpointsOverlay.getSource()
  if (rec[0]>gvar.autoID){
    gvar.autoID+=1;
  }
  let tmplon=parseFloat(rec[1]);
  let tmplat=parseFloat(rec[2]);
  if (isNaN(tmplon)){ tmplon=121.0 }
  if (isNaN(tmplat)){ tmplat=24.0 }
  let newpoint= new OlFeature({
    geometry: new OlGeomPoint(OlProjTransform([tmplon,tmplat],'EPSG:4326','EPSG:3857')),
    'id': rec[0],
    'name': rec[3],
    'inLine':rec[4],
  });
  newpoint.setId(rec[0]);
  pointsSource.addFeature(newpoint);
  return
  })
}
function PtJSON2StaTable(PtJson){
  //PtJson=data.points
  var chkVC=false
  var pointsSource=gvar.olpointsOverlay.getSource()
  for ( let i =1; i< PtJson.length; i++){
    if (gvar.autoID<PtJson[i][0]) { gvar.autoID=PtJson[i][0] };
    //console.log(['a',gvar.autoID]);
    let tmplon=parseFloat(PtJson[i][1]);
    let tmplat=parseFloat(PtJson[i][2]);
    PtJson[i][3]=PtJson[i][3].replace(/</g,'&lt;').replace(/>/g,'&gt;')
    if (isNaN(tmplon)){ tmplon=121.0 }
    if (isNaN(tmplat)){ tmplat=24.0 }
    let newpoint= new OlFeature({
      geometry: new OlGeomPoint(OlProjTransform([tmplon,tmplat],'EPSG:4326','EPSG:3857')),
      'id': PtJson[i][0],
      'name': PtJson[i][3],
    });
    newpoint.setId(PtJson[i][0]);
    pointsSource.addFeature(newpoint);
  };
  //gvar.points.forEach(Feature2StaTblRow.bind(null,chkVC)) 
  gvar.points.forEach(Feature2StaTblRow.bind(null,false)) 
  //console.log(['aaa:',gvar.autoID])
  //console.log(PtJson)
  //if (gvar.autoID<=PtJson[gvar.autoID][0]){
  //  gvar.autoID=PtJson[gvar.autoID][0]+1
  //}
  //plotPointFromStaTable();
}

function LnJSON2SchTable(LnJson){
  let demoT=document.getElementById("SchTable").getElementsByTagName("tbody")[0];
  if (LnJson==undefined){
    var tmpl=0
  }else{
    var tmpl=LnJson.length
  }
  for ( let i =1; i< tmpl; i++){
    let rec=LnJson[i]
    let row= SchTableAddRow(rec[0]);
    let tmprow=$(row)
    tmprow.find('td').eq(1).find('div').text(rec[1]);
    tmprow.find('td').eq(2).find('div').text(rec[2]);
    tmprow.find('td').eq(3).find('div').text(rec[3]);
    if (LnJson[i][4]){
      if (isNaN(parseFloat(LnJson[i][4]))){
        tmprow.find('td').eq(4).find('div').text('0.0');
      }else{
        tmprow.find('td').eq(4).find('div').text(LnJson[i][4]);
      }
    }else{
      tmprow.find('td').eq(4).find('div').text('0.0');
    }
    if (LnJson[i][5]){
      var workItem=LnJson[i][5];
      if (workItem=="{'item':['PT'],'other':''}"){
         workItem='{"item":["PT"],"other":""}';
      }
    }else{
      var workItem='{"item":["PT"],"other":""}';
    }
    tmprow.find('td').eq(5).find('div').attr("wkdata",workItem);
    tmprow.find('td').eq(5).find('div').eq(0).find('span').text(workItem2show(workItem));
  };
  plotLineFromSchTable();
}
function resetAll(){
  erasePoints();
  iniSchTable();
  document.getElementById("PlanName").value='';
  var tmpa=gvar.cplanlinesource.getFeatures();
  if(tmpa.length>0){
    for ( let i = 0; i < tmpa.length; i++ ) {
      gvar.cplanlinesource.removeFeature(tmpa[i]);
    };
  };
  gvar.cPlanVC=''; // kill all version control,
  gvar.imgMapArr=[];
  $('#imgs4pdf > img').remove();
  gvar.points = gvar.olpointsOverlay.getSource().getFeatures();
  gvar.autoID=-1;
  gvar.autoSchID=0;
  $('#imgs4pdf > .closebtn').remove();
  $('#imgs4pdf > .a4needico').remove();
  gvar.cPlanJSON={
    'points':[],
    'line':[]
    //'cPlanName':'',
    //'cPlanInfo':{}
  }
  gvar.cPlanJSON.points.push(gvar.StaData.ptHead);
  gvar.cPlanJSON.line.push(gvar.SchData.lineHead);
  gvar.cPlanVC= new VersionControlled(gvar.cPlanJSON)
  gvar.cPlanJSON=gvar.cPlanVC.data;
}
function loadPlan(planname) {
  var pointsSource=gvar.olpointsOverlay.getSource()
  var url='/odbintl/rasters/getcplan/?datatype=table&';
  url+='name='+encodeURIComponent(planname);
  $.getJSON(url, function(data){
    resetAll();
    document.getElementById("PlanName").value=planname;
    if (data.cPlanInfo){
      gvar.cPlanInfo=data.cPlanInfo;
    }
    PtJSON2StaTable(data.points)
    gvar.cPlanJSON.points=data.points;
    /*
    for ( let i =1; i< data.points.length; i++){
      gvar.autoID+=1;
      let tmplon=parseFloat(data.points[i][1]);
      let tmplat=parseFloat(data.points[i][2]);
      if (isNaN(tmplon)){ tmplon=121.0 }
      if (isNaN(tmplat)){ tmplat=24.0 }
      let newpoint= new OlFeature({
        geometry: new OlGeomPoint(OlProjTransform([tmplon,tmplat],'EPSG:4326','EPSG:3857')),
        'id': data.points[i][0],
        'name': data.points[i][3],
      });
      pointsSource.addFeature(newpoint);
    };
    gvar.points.forEach(Feature2StaTblRow)
    // check the autoID is same as the maximum of the plan data
    if (gvar.autoID<=data.points[gvar.autoID][0]){
      gvar.autoID=data.points[gvar.autoID][0]+1
    }
    */
    //gvar.cPlanJSON.points=gvar.StaData.point; //1218
    gvar.cPlanJSON.line=data.line;
    LnJSON2SchTable(data.line);
    gvar.cPlanVC= new VersionControlled(gvar.cPlanJSON)
    gvar.cPlanJSON=gvar.cPlanVC.data;
    $("#undobtn").addClass("disabled")
    $("#redobtn").addClass("disabled")
    //$('#ent_sensea_time').datepicker('setDate', 'now');
    /*
    let demoT=document.getElementById("SchTable").getElementsByTagName("tbody")[0];
    
    for ( let i =1; i< data.line.length; i++){
      let row = demoT.insertRow(demoT.rows.length);
      let cell0 = row.insertCell(0);
      let cell1 = row.insertCell(1);
      let cell2 = row.insertCell(2);
      let cell3 = row.insertCell(3);
      let cell4 = row.insertCell(4);
      let cell5 = row.insertCell(5);
      let cell6 = row.insertCell(6);
      let Div0=document.createElement('div');
      Div0.setAttribute("contenteditable","true");
      Div0.innerHTML=data.line[i][0];
      let Div1=document.createElement('div');
      Div1.innerHTML=data.line[i][1];
      let Div2=document.createElement('div');
      Div2.setAttribute("contenteditable","true");
      Div2.setAttribute("onclick","gvar.chkShipSpdByHrs=false;selectText(this)");
      Div2.innerHTML=data.line[i][2];
      let Div3=document.createElement('div');
      Div3.setAttribute("contenteditable","true");
      Div3.setAttribute("onclick","gvar.chkShipSpdByHrs=true; selectText(this)");
      //Div3.setAttribute("onClick","selectText(this);")
      Div3.innerHTML=data.line[i][3];
      var Div4=document.createElement('div');
      Div4.setAttribute("contenteditable","true");
      Div4.setAttribute("onclick","selectText(this)");
      if (data.line[i][4]){
        if (isNaN(parseFloat(data.line[i][4]))){
          Div4.innerHTML=0.0;
        }else{
          Div4.innerHTML=parseFloat(data.line[i][4]);
        }
      }else{
        Div4.innerHTML=0.0;
      }
      var Div5=document.createElement('div');
      if (document.getElementById("setWorkItem").checked){
        Div5.setAttribute("class","workItem");
      }else{
        Div5.setAttribute("class","workItem hide");
      }
      var tmpSpan=document.createElement('SPAN');
      if (data.line[i][5]){
        var workItem=data.line[i][5];
        if (workItem=="{'item':['PT'],'other':''}"){
           workItem='{"item":["PT"],"other":""}';
        }
      }else{
        var workItem='{"item":["PT"],"other":""}';
      }
      tmpSpan.innerHTML=workItem2show(workItem);
      Div5.setAttribute("wkdata",workItem);
      
      Div5.appendChild(tmpSpan);
      gvar.autoSchID+=1;
      var tmpwkitemid="wkitem"+gvar.autoSchID
      cell5.setAttribute("id",tmpwkitemid);
     
      $(cell5).click(function(){
        buildWorkItem($(this).attr('id'),$(this).children().attr('wkdata'))
      })
      var Div6=document.createElement('span');
      if (i >0){
        var Span1=document.createElement('span');
        Span1.setAttribute("class","table-remove glyphicon glyphicon-remove");
        Span1.onclick=function(e){var child=this.parentNode.parentNode; var tparent=child.parentNode; tparent.removeChild(child); plotLineFromSchTable()};
        cell6.appendChild(Span1);
      }
      cell0.appendChild(Div0);
      cell1.appendChild(Div1);
      cell2.appendChild(Div2);
      cell3.appendChild(Div3);
      cell4.appendChild(Div4);
      cell5.appendChild(Div5);
      cell6.appendChild(Div6);
      cell1.setAttribute("style","color:#ccc;");
    };
    plotLineFromSchTable();
    */
  });
}
function workItem2show(wkitem){
  var tmpobj=JSON.parse(wkitem);
  var tmpstr="點擊以設定工作項目";
  var chkitem=false
  if (tmpobj.item){
    if (tmpobj.item[0]!="PT" ){
      tmpstr=tmpobj.item.join(",");
      chkitem=true;
    }
  }
  if (tmpobj.other!=""){
    if (chkitem) {
      tmpstr+=","+tmpobj.other
    }else{
      tmpstr=tmpobj.other
    }
  }
  return tmpstr
}
export function saveTable() {
  plotPointFromStaTable();
  plotLineFromSchTable();
  //var data=gvar.StaData.point;
  if (! $("#PlanName").val()){
    if ($("#PlanName").val()==''){
      let tmpstr=$('#username').data('username')+'_'
      tmpstr+=new Date().toISOString().slice(0,19).replace(/-/g,"").replace(/:/g,"");
      $("#PlanName").val(tmpstr);
    }
  }
  /*
  var obj={
    'points':gvar.StaData.point,
    'line':gvar.SchData.line,
    'cPlanName':document.getElementById("PlanName").value,
    'cPlanInfo':gvar.cPlanInfo
  }
  */
  var json=collectAllcPlanData()
  return json
  //return collectAllcPlanData()
}
function collectAllcPlanData(){
  gvar.cPlanName=document.getElementById("PlanName").value
  var dataOut={}
  dataOut["cPlanName"]=gvar.cPlanName;
  dataOut["cPlanInfo"]=gvar.cPlanInfo;
  for (var key in gvar.cPlanJSON){
    if (key=='points'){
      dataOut[key]=[]
      for (var key2 in gvar.cPlanJSON[key]){
        if (gvar.cPlanJSON[key][key2][0] != -1) {
          dataOut[key].push(gvar.cPlanJSON[key][key2])
        }
      }
    }else{
      dataOut[key]=gvar.cPlanJSON[key];
    }
  }
  //console.log(dataOut)
  //var json=JSON.stringify(gvar.cPlanJSON);
  return JSON.stringify(dataOut);
}

function exportTable() {
  plotPointFromStaTable();
  //var data=gvar.StaData.point;
  var data=gvar.cPlanJSON.points;
  var csvContent = "data:text/csv;charset=utf-8,\uFEFF";
  let dataString;
  csvContent += "number of Sites,"+(data.length-1).toString()+"\n";
  data.forEach(function(infoArray, index){
    dataString = infoArray.join(",");
    csvContent += index < data.length ? dataString+ "\n" : dataString;
   });
  if ("line" in gvar.SchData) {
    data=gvar.SchData.line;
    csvContent += "Schedule,"+(data.length-1).toString()+"\n";
    data.forEach(function(infoArray, index){
      dataString = infoArray.join(",");
      csvContent += index < data.length ? dataString+ "\n" : dataString;
     });
  };
  var cruisestatic=document.getElementById("cruisestatics");
  csvContent += cruisestatic.textContent+"\n";
  //console.log(csvContent);
  return encodeURI(csvContent);
};
function  Map2DataUrl() {
  var mapCanvas = document.createElement('canvas');
  var size=map.getSize();
  [mapCanvas.width, mapCanvas.height] = size;
  var mapContext = mapCanvas.getContext('2d');
  Array.prototype.forEach.call(document.querySelectorAll('.ol-layer canvas'), function(canvas) {
    if (canvas.width > 0) {
      var opacity = canvas.parentNode.style.opacity;
      mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
      var transform = canvas.style.transform;
      // Get the transform parameters from the style's transform matrix
      var matrix = transform.match(/^matrix\(([^\(]*)\)$/)[1].split(',').map(Number);
      // Apply the transform to the export map context
      CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
      mapContext.drawImage(canvas, 0, 0);
    }
  });
  return mapCanvas.toDataURL("image/png");
}
function  exportMap() {
  //var canvas = $('canvas').get(0);
  map.once('rendercomplete', function() {
    var mapCanvas = document.createElement('canvas');
    var size=map.getSize();
    [mapCanvas.width, mapCanvas.height] = size;
    var mapContext = mapCanvas.getContext('2d');
    Array.prototype.forEach.call(document.querySelectorAll('.ol-layer canvas'), function(canvas) {
      if (canvas.width > 0) {
        var opacity = canvas.parentNode.style.opacity;
        mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
        var transform = canvas.style.transform;
        // Get the transform parameters from the style's transform matrix
        var matrix = transform.match(/^matrix\(([^\(]*)\)$/)[1].split(',').map(Number);
        // Apply the transform to the export map context
        CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
        mapContext.drawImage(canvas, 0, 0);
      }
    });
    if (navigator.msSaveBlob) {
      // link download attribuute does not work on MS browsers
      navigator.msSaveBlob(mapCanvas.msToBlob(), 'map.png');
    } else {
      var link = document.getElementById('image-download');
      link.href = mapCanvas.toDataURL();
      link.click();
    }
  });
  map.renderSync();
};
function setDPI(canvas,dpi){
  var scaleFactor = dpi / 96;
  canvas.width = Math.ceil(canvas.width * scaleFactor);
  canvas.height = Math.ceil(canvas.height * scaleFactor);
  var ctx=canvas.getContext("2d");
  ctx.scale(scaleFactor, scaleFactor);
}
function chkSwitch(){
  if (! document.getElementById('isolgraticuleSelected').checked){
    document.getElementById('isolgraticuleSelected').click();
  }
}
async function sleep(ms){
    return new Promise(res => setTimeout(res,ms));
}
async function uploadMap() {
  read_uploadmap();
  //var dataURL = $('canvas').get(0).toDataURL("image/png");
  var imgs=[];
  var imgsinfo=[];
  //imgs.push(document.getElementById('img4pdf1').src);
  //console.log(gvar.imgMapArr.length)
  for (let tmpi=0; tmpi < gvar.imgMapArr.length; tmpi+=1){
    imgs.push(gvar.imgMapArr[tmpi].src);
    let tmpinfo={'size':gvar.imgMapArr[tmpi].getAttribute('data-mapsize'),'extent':gvar.imgMapArr[tmpi].getAttribute('data-mapextent'),
                 'a4need':gvar.imgMapArr[tmpi].a4need}; //A4_need
    //console.log("Push A4-need into SubImgsInfo: ", gvar.imgMapArr[tmpi].a4need);
    imgsinfo.push(tmpinfo);
  }
  await sleep(500)
  //console.log("Final push imgsinfo in Json is: ", JSON.stringify(imgsinfo));
  gvar.cPlanInfo['SubImgsInfo']=JSON.stringify(imgsinfo);
  $('#cPlanInfo').val(saveTable());
  //document.getElementById('map4upload').value = document.getElementById('img4pdf1').src;
  $('#mapImgs4upload').val(imgs);
  $('#mapImgsInfo').val(gvar.cPlanInfo['SubImgsInfo']);
  //document.getElementById('mapImgsInfo').value = gvar.cPlanInfo['SubImgsInfo'];

  //jQuery(document).ready(function($){
    //submitTable(); // 記得，子影像邊界產生後才存檔。
      $('#uploadmap').submit();
    //document.getElementById('uploadmap').submit();
  //})
}
function switchToggle(toggleID){
  toggleID='#'+toggleID;
  if (document.getElementById('ChkLineMod').checked || document.getElementById('setWorkItem').checked){
    if ($(toggleID).is(":hidden")){
      $(toggleID).collapse('toggle')
    }
  }else{
    if (! $(toggleID).is(":hidden")){
      $(toggleID).collapse('toggle')
    }
  }
}

function zoomInMap2depth( lon,lat ) {
  var nmap=$('#map').data('map');
  nmap.getView().setCenter(OlProjTransform([lon,lat], 'EPSG:4326', 'EPSG:3857'))
  //nmap.getView().setZoom(16)
}
function changemap( maptype ) {
  var nmap=$('#map').data('map');
  maptype=maptype.replace('basemap_','');
  nmap.getLayers().forEach(function(layer){
    if (layer instanceof OlLayerGroup){
      //console.log(layer.get('name'));
      if (layer.get('name') == 'BasemapGroup'){
        layer.getLayers().forEach(function(sublayer){
          if ( sublayer.get('name')==maptype){
            sublayer.setVisible(true)
          } else {
            sublayer.setVisible(false)
          }
        })
      };
    }
  });
}

function switchLineOfLaw( maptype ) {
  var nmap=$('#map').data('map');
  nmap.getLayers().forEach(function(layer){
    if (layer instanceof OlLayerGroup){
      //console.log(layer.get('name'));
      //console.log(maptype);
      if (layer.get('name') == 'lawOfLines'){
        layer.getLayers().forEach(function(sublayer){
          if ( sublayer.get('name')==maptype){
            var isSelectedId="is"+maptype+"Selected";
            if (document.getElementById(isSelectedId).checked) {
              sublayer.setVisible(true);
            }else{
              sublayer.setVisible(false);
            };
          }
        })
      };
    }
  });
}
/*function switchGraticule(switchname){
  var isSelectedId="is"+switchname+"Selected";
  var nmap=$('#map').data('map');
  if (document.getElementById(isSelectedId).checked) {
    gvar.olgraticule.setMap(nmap);
  }else{
    gvar.olgraticule.setMap(null);
  };
}*/
function changeLayerTime( maptype, newTime ) {
  var nmap=$('#map').data('map');
  nmap.getLayers().forEach(function(layer){
    if ( layer.get('name')==maptype){
      var isSelectedId="is"+maptype+"Selected";
      if (document.getElementById(isSelectedId).checked) {
        layer.setVisible(true);
        var loc=layer.getSource().getUrls()[0];
        loc=loc.split("?")[0]+"?Time="+newTime;
        Himawari8Source.setUrl(loc);
      }else{
        layer.setVisible(false);
      };
    }
  });
}
function switchLayer(tmpLayerName) {
  let nmap=$('#map').data('map');
  let isSelectedId="is"+tmpLayerName+"Selected";
  //let tmpL = gvar.Layers[LayerName]
  /*if (tmpL === undefined){
    tmpL=gvar.Layers
  }*/
  //console.log(tmpLayerName)
  //console.log('tmpLayerName')
  gvar.Layers[tmpLayerName].setVisible(
    document.getElementById(isSelectedId).checked
  );
}
function switchShipTrackLayer(maptype){
  var nmap=$('#map').data('map');
  nmap.getLayers().forEach(function(layer){
    if (layer instanceof OlLayerGroup){
      //console.log(layer.get('name'));
      //console.log(maptype);
      if (layer.get('name') == 'ShipTrackLayers'){
      //console.log(maptype);
        layer.getLayers().forEach(function(sublayer){
          if ( sublayer.get('name')==maptype){
            var trackCheckId=maptype;
            //console.log(trackCheckId);
            sublayer.setVisible(document.getElementById(trackCheckId).checked);
          }
        })
      }
    }
  });
}
function textstylefunction(feature){
  let style =  new OlStyleStyle({
    fill: new OlStyleFill({
      color: 'rgba(255, 255, 255, 0.6)'
    }),
    stroke: new OlStyleStroke({
      color: '#319FD3',
      width: 1
    }),
    text: new OlStyleText({
      textAlign: "center",
      font: '20px 標楷體, Calibri, sans-serif',
      text: getText(feature),
      fill: new OlStyleFill({
        color: 'rgba(255, 255, 255, 1)'
      }),
      stroke: new OlStyleStroke({
        color: 'rgba(0, 0, 0, 1)',
        width: 0.5
      })
    })
  })
  return style;
};
function getText(feature){
  var text = feature.get('namechar');
  return text;
};
function createDepLayer (map){
  mapextent=OlProjTransformExtent(map.getView().calculateExtent(map.getSize()),'EPSG:3857','EPSG:4326');
  var depvalue = new OlLayerVector({
    name: 'depvalue',
    source: new OlSourceVector({
      url: '/odbintl/rasters/getdep/taidp200m_raw/'+map.getView().getZoom()+'/'+mapextent,
      format: new OlFormatGeoJSON()
    }),
   style: textstylefunction
  });
  return depvalue;
};
function createLineOfLawLayer(Lrs,staticUrl){
  //let Lrs={}
  /*Lrs.CN_24nm_line = new OlLayerVector({
    name: 'CN_24nm_line',
    desc_cn:"中國大陸24浬鄰接區外界線",
    visible: false,
    source: new OlSourceVector({
      url: staticUrl+"cmd/law/CN_24nm_line.geojson?y=1",
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(15,205,115,0.7)',
        width: 4
      })
    })
  });*/
  Lrs.newCN_24nm_line = new OlLayerVector({
    name: 'newCN_24nm_line',
    desc_cn:"中國聲明領海基線延伸24浬界線",
    visible: false,
    source: new OlSourceVector({
      url: staticUrl+"cmd/law/China_24nm_new.geojson",
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(15,205,115,0.7)',
        width: 4
      })
    })
  });
  Lrs.BaseLine = new OlLayerVector({
    name: 'BaseLine',
    desc_cn:"領海基線",
    visible: false,
    source: new OlSourceVector({
      url: staticUrl+"cmd/law/BaseLine_new.geojson",
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(165,235,255,0.7)',
        width: 4
      })
    })
  });
  Lrs.BLof12nm = new OlLayerVector({
    name: 'BLof12nm',
    desc_cn:"12浬領海外界線",
    visible: false,
    source: new OlSourceVector({
      //url: gvar.staticUrl+"cmd/law/new12nmBL.geojson",
      url: staticUrl+"cmd/law/12nmBL_new.geojson",
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(155,255,255,0.7)',
        width: 4
      })
    })
  });
  Lrs.BLof24nm = new OlLayerVector({
    name: 'BLof24nm',
    desc_cn:"24浬鄰接區外界線",
    visible: false,
    source: new OlSourceVector({
      //url: gvar.staticUrl+"cmd/law/new24nmBL.geojson",
      url: staticUrl+"cmd/law/24nmBL_new.geojson",
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(255,155,255,0.7)',
        width: 4
      })
    })
  });
  Lrs.EEZ = new OlLayerVector({
    name: 'EEZ',
    desc_cn:"專屬經濟海域",
    visible: false,
    source: new OlSourceVector({
      url: staticUrl+"cmd/law/EEZ.geojson",
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(255,255,155,0.7)',
        width: 4
      })
    })
  });
  Lrs.TSmidLine = new OlLayerVector({
    name: 'TSmidLine',
    desc_cn:"海峽中間線",
    visible: false,
    source: new OlSourceVector({
      url: staticUrl+"cmd/law/TSmidLine_4326_new.geojson",
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(255,55,155,0.7)',
        width: 4
      })
    })
  });
  Lrs.JCmidLine = new OlLayerVector({
    name: 'JCmidLine',
    desc_cn:"日本主張專屬經濟海域西南界線",
    visible: false,
    source: new OlSourceVector({
      url: staticUrl+"cmd/law/JCmidLine_4326.geojson",
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(155,85,155,0.7)',
        width: 4
      })
    })
  });
  Lrs.TaiPingIslandLimLine = new OlLayerVector({
    name: 'TaiPingIslandLimLine',
    desc_cn:"金馬南沙地區限制水域",
    visible: false,
    source: new OlSourceVector({
      url: staticUrl+"/cmd/law/KMNlimLine_4326.geojson",
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(215,55,155,0.7)',
        width: 4
      })
    })
  });
  Lrs.KMlimLine = new OlLayerVector({
    name: 'KMlimLine',
    desc_cn:"金馬南沙地區禁止水域",
    visible: false,
    source: new OlSourceVector({
      url: staticUrl+"cmd/law/KMNforbidLine_4326.geojson?rnd="+Math.random().toString(36).substring(7),
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(255,255,155,0.7)',
        width: 4
      })
    })
  });
  Lrs.PhilippinesEEZ = new OlLayerVector({
    name: 'PhilippinesEEZ',
    desc_cn:"EEZ_菲律賓",
    visible: false,
    source: new OlSourceVector({
      url: staticUrl+"cmd/law/PhilippinesEEZ.geojson?rnd="+Math.random().toString(36).substring(7),
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(155,75,155,0.7)',
        width: 4
      })
    })
  });
  Lrs.FishProtLine = new OlLayerVector({
    name: 'FishProtLine',
    desc_cn:"護漁範圍",
    visible: false,
    source: new OlSourceVector({
      url: staticUrl+"/cmd/law/FishProtLine_4326.geojson",
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(255,215,175,0.7)',
        width: 4
      })
    })
  });
  Lrs.TempEnforcementLine = new OlLayerVector({
    name: 'TempEnforcementLine',
    desc_cn:"暫定執法線",
    visible: false,
    source: new OlSourceVector({
      url: staticUrl+"/cmd/law/TempEnforcementLine.geojson",
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(155,155,255,0.7)',
        width: 4
      })
    })
  });
  Lrs.TJFishAggrement = new OlLayerVector({
    name: 'TJFishAggrement',
    desc_cn:"臺日漁業協議適用海域",
    visible: false,
    source: new OlSourceVector({
      url: staticUrl+"cmd/law/TJ_Fisheries_Agreement.geojson",
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(0,125,0,0.7)',
        lineDash:[4],
        width: 2
      }),
      fill: new OlStyleFill({
        color:'rgba(0,125,0,0.2)'
      })
    })
  });
  Lrs.TJFishAggrementSpecial = new OlLayerVector({
    name: 'TJFishAggrementSpecial',
    desc_cn:"臺日漁業協議特別合作海域",
    visible: false,
    source: new OlSourceVector({
      url: staticUrl+"cmd/law/TJ_Fisheries_Agreement_special.geojson",
      format: new OlFormatGeoJSON()
    }),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(0,145,0,0.7)',
        lineDash:[4],
        width: 2
      }),
      fill: new OlStyleFill({
        color:'rgba(0,145,0,0.5)'
      })
    })
  });
  // set typhoon track id with typhoon id
  var TTsource=new OlSourceVector({});
  fetch("/odbintl/wfs/typhoontrack/")
    .then(response => response.json())
    //.then(json => console.log(json));
    .then(json => {
      var format = new OlFormatGeoJSON();
      var features = format.readFeatures(json);
      var tracks=features[0]
      features.forEach(function(track){
        if (track.getGeometry()){
          track.setId(track.get('info')[1]);
          track.getGeometry().transform('EPSG:4326','EPSG:3857')
          TTsource.addFeature(track);
        }else{
          //console.log(track.get('info'));
        }
      })
    }) 
  Lrs.TyphoonTracks = new OlLayerVector({
    name: 'TyphoonTracks',
    desc_cn:"歷史颱風路徑",
    visible: false,
    source: TTsource,
    //source: new OlSourceVector({
    //  url: "/odbintl/wfs/typhoontrack/",
    //  format: new OlFormatGeoJSON()
    //}),
    style: new OlStyleStyle({
      stroke: new OlStyleStroke({
        color:'rgba(155,155,255,0.3)',
        width: 1
      })
    })
  });
  /*Lrs.EEZ_Philippines = new OlLayerTile({
    name: 'EEZ_Philippines',
    desc_cn: 'EEZ_菲律賓',
    opacity: 0.2,
    visible: false,
    source: new OlSourceTileWMS({
      url: 'https://geo.vliz.be/geoserver/wms',
      params: {
        'LAYERS': 'MarineRegions:eez',
        'STYLES':'gazetteer_red',
        'TRANSPARENT':'TRUE',
        'CQL_FILTER':'mrgid_eez=8322',//philippines
        'VERSION':'1.1.1'
      }
    })
  });*/
  /*
  Lrs.ShipTrack= new OlLayerVectorTile({
    name:"ShipTrack",
    visible: false,
    source: new OlSourceVectorTile({
      format: new OlFormatGeoJSON(),
      tileGrid: new OlTilegridCreateXYZ({ maxZoom:19 }),
      url: 'https://odbwms.oc.ntu.edu.tw/odbintl/odbtest/trackdata/{z}/{x}/{y}.geojson?rvname=or1&year=2011'
    })
  });
   var lawOfLine = new OlLayerGroup({
    name:'lawOfLines',
    layers: [ ShipTrack, CN_24nm_line,BaseLine,BLof12nm,BLof24nm,EEZ,TempEnforcementLine,TSmidLine,JCmidLine,KMlimLine, TaiPingIslandLimLine]
  });
  return lawOfLine;
  */
  return Lrs;
};
var createShipTrackLayer= function(){
  var shiplayers=[];
  var ships=['or1','or2'];
  for (var i=0; i<ships.length; i++){
    var rvname=ships[i];
    for ( var yr =2010; yr <2015; yr++){
      var stryear=yr.toString();
      var ShipTrack= new OlLayerVectorTile({
        name:rvname+"_"+stryear,
        visible: false,
        source: new OlSourceVectorTile({
          format: new OlFormatGeoJSON(),
          tileGrid: new OlTilegridCreateXYZ({ maxZoom:19 }),
          url: 'https://odbwms.oc.ntu.edu.tw/odbintl/odbtest/trackdata/{z}/{x}/{y}.geojson?rvname='+rvname+'&year='+stryear
        }),
        style: new OlStyleStyle({
          stroke: new OlStyleStroke({
            color:'rgba(155,155,155,0.5)',
            width: 1
          })
        })
      });
      shiplayers.push(ShipTrack);
    };
  };
  var ShipTracks = new OlLayerGroup({
    name:'ShipTrackLayers',
    layers: shiplayers
  });
  return ShipTracks;
};
function exportPDF(){
  var doc=new jsPDF();
  doc.setFont('GenYoGothicTW-Regular')
  doc.text('「新海研1號」研究船出海作業申請單',10,10)
  doc.text('aaa ',10,10)

  var string = doc.output('datauristring');
  var embed = "<embed width='100%' height='100%' src='" + string + "'/>"
  var x = window.open();
  x.document.open();
  x.document.write(embed);
  x.document.close();
  //doc.save('cplan1.pdf')
}
function highlightStyleFunction(feature, resolution){
  var style;
  var nmap=$('#map').data('map');
  var zoom=nmap.getView().getZoom();
  var font_size=24;
  var im_rds=8;
  var im_fill_clr='rgba(0,0,255,0.5)';
  var geom = feature.getGeometry();
  let hasID= feature.getKeys().indexOf('ID');
  var strSiteNameBy=hasID>=0? "ID" : "id"; //"id" modified by cywhale SL
  if (feature.getGeometry().getType()=="LineString"){
    strSiteNameBy="name";
  }else{
    if (document.getElementById("chkShowSiteName").checked){
      strSiteNameBy="name";
    }
  }
  style= defaultStyle(24,6,'rgba(255,0,0,0.9)')
  var textStr= '  '+feature.get(strSiteNameBy)
  style.getText().setText(textStr);
  return [style];
}
function defaultStyle(font_size,im_rds,im_fill_clr){
  var style;
  if (font_size === undefined) {
    font_size=18;
  }
  if (im_rds === undefined) {
     im_rds=4;
  }
  if (im_fill_clr === undefined) {
     im_fill_clr='#ffcc33';
   }
  style= new OlStyleStyle({
    fill: new OlStyleFill({
      color: 'rgba(255, 255, 255, 0.5)'
    }),
    stroke: new OlStyleStroke({
      color: '#ffcc33',
      width: 2
    }),
    image: new OlStyleCircle({
      radius: im_rds,
      fill: new OlStyleFill({
        color: im_fill_clr
      })
    }),
    text:  new OlStyleText({
      //font: '300 ' + font_size+'px Noto Sans T Chinese,sans-serif',
      font:  font_size+'px Noto Sans T Chinese,sans-serif',
      textAlign: 'end',
      rotation: -0.785398164,
      fill: new OlStyleFill({color:"#aa3300"}),
      stroke: new OlStyleStroke({color:"#ffffff", width:3})
    })
  })
  return style;
}
function styleFunction(feature, resolution){
  var style;
  var font_size=24;
  var im_rds=4;
  var im_fill_clr='#ffcc33';
  let hasID= feature.getKeys().indexOf('ID');
  var strSiteNameBy=hasID>=0? "ID" : "id"; //"id" modified by cywhale SL
  //console.log(resolution);
  if (feature.getGeometry().getType()=="LineString"){
    strSiteNameBy="name";
  }else{
    if (document.getElementById("chkShowSiteName").checked){
      strSiteNameBy="name";
    }
  }
  var geom = feature.getGeometry();
  style=defaultStyle();
  var textStr= '  '+feature.get(strSiteNameBy)
  style.getText().setText(textStr);
  return [style];
}
function disableInteraction(){
  var nmap=$('#map').data('map');
}
function setMapInteraction(){
  var nmap=$('#map').data('map');
//graticule.setMap(nmap);
  gvar.pt4highlight.setMap(nmap);
  gvar.olpointsOverlay.setMap(nmap);
  var modify = new OlInteractionModify({
    features: gvar.olfeatures,
    deleteCondition: function(event) {
      return OlEventsConditionShiftKeyOnly(event) &&
          OlEventsConditionSingleClick(event);
    }
  });
  nmap.addInteraction(modify);
  /*var mouseWheelZoom= new OlMouseWheelZoom({
    maxDelta:10,
    delta:1,
    cumulative:true
  })
  nmap.addInteraction(mouseWheelZoom);*/
  var layerSelect= new OlInteractionSelect({
    condition: OlEventsConditionClick 
  })
  nmap.addInteraction(layerSelect);

  layerSelect.on('select',function(e){
    //console.log(e.selected[0].getProperties().id);
    SchTableAddRow(e.selected[0].getProperties().id);
    //console.log('abc')
    //plotLineFromSchTable();
    //layerSelect.getFeatures().clear();
    $.when(plotLineFromSchTable()).then(function(){
      gvar.cPlanJSON.line=gvar.SchData.line;
    });
    layerSelect.getFeatures().clear();
  })

  layerSelect.setActive(false);
  gvar.oldrawcplan= new OlInteractionDraw({
    features: gvar.olfeatures,
    type:"Point"
  });
  nmap.addInteraction(gvar.oldrawcplan);
  
  var linelayer=new OlLayerVector({
    source: gvar.cplanlinesource,
    style: gvar.olstyleFunction
  });
  nmap.addLayer(linelayer);
/*  // The snap interaction must be added after the Modify and Draw interactions
  // in order for its map browser event handlers to be fired first. Its handlers
  // are responsible of doing the snapping.
  var snap = new OlInteractionSnap({
    source: gvar.olpointsOverlay.getSource()
  });
  nmap.addInteraction(snap);
*/
  gvar.oldrawcplan.on('drawend',function(e2){
    gvar.points = gvar.olpointsOverlay.getSource().getFeatures();
    //let ids=[];
    //for (let i=0; i<gvar.points.length; i++){
    //  ids.push(gvar.points[i].getProperties().id);
    //}
    //gvar.autoID=gvar.autoID+1;
    //while(ids.indexOf(gvar.autoID)>=0){
      gvar.autoID += 1;
    //}
    e2.feature.setId(gvar.autoID);
    e2.feature.setProperties({
      'id': gvar.autoID,
      'name': 'site'+gvar.autoID.toString(),
      //'staHr': 0.0,
      'workItem': '{"item":["PT"],"other":""}'
    });
    gvar.oldrawcplan.setActive(false); // avoid double click which will duplicate points
    if ($('#StaTable > tbody').length==0){
      iniStaTable();
      gvar.points.forEach(Feature2StaTblRow.bind(null,false));
    }
    let tmprec=Feature2StaTblRow(true, e2.feature, gvar.autoID);
    //let tmprec=Feature2StaTblRow(true, e2.feature, gvar.points.length);
    if (document.getElementById("ChkAutoLine").checked){
      SchTableAddRow(gvar.autoID);
      $.when(plotLineFromSchTable()).then(function(){
        gvar.cPlanJSON.line=gvar.SchData.line;
      });
    //}else{
    //  plotLineFromSchTable();
    };
  });
  modify.on('modifyend',function(e){
    gvar.points = gvar.olpointsOverlay.getSource().getFeatures();
    var tmpchk=false
    e.target.dragSegments_.forEach(function(s){
    //var tmpfeature=e.target.dragSegments_[0][0].feature
    var tmpfeature=s[0].feature
    //console.log(['id',tmpfeature.getId()])
    var ptid=tmpfeature.getId();
    Feature2StaTblRow(true,tmpfeature,ptid)
    if (!tmpchk){ 
      if (ptInSchTable(ptid)) {tmpchk=true }
    }
    })
    //iniStaTable();
    //gvar.points.forEach(Feature2StaTblRow);
    //plotPointFromStaTable();
    //gvar.cPlanJSON.points=gvar.StaData.point;
    //JSONVC();
    //console.log(gvar.StaData.point)
    //plotLineFromSchTable();
    if (tmpchk) {
      //程式自動依點位調整，不進行版本控制
      plotLineFromSchTable()
      //gvar.cPlanJSON.line=gvar.SchData.line
    }
  });
// show lon, lat of mouse position on the map
  var mousePosition = new OlControlMousePosition({
    coordinateFormat: function(coordinate) {
      let lon = coordinate[0];
      let lat = coordinate[1];
      lon = lon % 360;
      lon < 0 ? lon += 360 : lon;
      /*if (lon > 180) {  
        lon = lon - 360;
      } else if (lon < -180) {
        lon = 360 + lon;
      }*/
      return OlCoordinateFormat([lon, lat], "{x}, {y}", 4);
    },
    projection: 'EPSG:4326',
    target: document.getElementById('mouse-position'),
    undefinedHTML: '&nbsp;'
  });
  nmap.addControl(mousePosition);
// when mouse pointer not on the map, hide the cursor
  //nmap.getViewport().addEventListener('mouseout', function() {
  nmap.getViewport().addEventListener('mouseleave', function() {
    gvar.oldrawcplan.setActive(false);
    layerSelect.setActive(false);
    modify.setActive(false);
  });
  //nmap.getViewport().addEventListener('mouseover', function() {
  nmap.getViewport().addEventListener('mouseenter', function() {
    //gvar.oldrawcplan.setActive(true);
    //layerSelect.setActive(false);
    modify.setActive(!document.getElementById("ChkLineMod").checked && gvar.chkMapModify);
  });

// when mouse pointer over the points(sites), change the cursor and disable draw (avoid add new point in the same location)
  var target = nmap.getTarget(),
    jTarget = typeof target === "string" ? $("#" + target) : $(target);
  $(nmap.getViewport()).on('mousemove', function(e) {
    var pixel = nmap.getEventPixel(e.originalEvent);
    //console.log(pixel);
    var hit = nmap.forEachFeatureAtPixel(pixel, function(f) {
      let tmpId=f.getId();
      let tmpObj=$(`#StaTable tbody > tr > td:nth-child(1)`).filter(function(){return $(this).text()==`${tmpId}`})
      tmpObj[0].scrollIntoView({block:"nearest"});
      animateHighlight(tmpObj,"rgb(255, 255, 156)",1000)
      return true;
    },{
      layerFilter: function (layer) {
        return layer.get('name') === 'points';
      }
    });
    if (hit) {
      if (document.getElementById("ChkLineMod").checked){
        jTarget.css("cursor", "pointer");
      }else{
        jTarget.css("cursor", "move");
      }
      gvar.oldrawcplan.setActive(false);
      layerSelect.setActive(document.getElementById("ChkLineMod").checked && gvar.chkMapModify);
    } else {
      jTarget.css("cursor", "");
      gvar.oldrawcplan.setActive(!document.getElementById("ChkLineMod").checked && gvar.chkMapModify);
      layerSelect.setActive(false);
    }
  });
};
function modifyStaTable(StaTableId,rec){
  let tmps=`#${StaTableId} tbody tr td:nth-child(1)`
  let rowIdx=$(tmps).filter(`:contains(${rec[0]})`).parent().index()
  if (rowIdx<0){
    //console.log('can not find rec in StaTable, append it!')
    appendStaTable(StaTableId,rec)
  }else{
    var demoT=$(`#${StaTableId} tbody tr:eq(${rowIdx})`);
    for (let tmpi=1; tmpi<=3; tmpi++){
      demoT.find(`td:eq(${tmpi})`).find('div').html(rec[tmpi])
    }
  }
}

function onShowLabel(obj){ //modified by cywhale SL
  //console.log("Tigger onShowLabel"); //obj.value, obj.checked);
  plotPointFromStaTable();
}

function appendStaTable(StaTableId,rec,ForceAppend=false){
  /*
 * ForecAppend will skip check if the points exist.
 * rec=[id, lon, lat, name]*/

  //let StaTableId="StaTable"
  let tblObj=document.getElementById(StaTableId);
  let demoT=tblObj.getElementsByTagName('tbody')[0];
  let tbodyRowCount=demoT.rows.length
  let minId=Number($(`#StaTable tbody>tr:nth-child(1) >td:nth-child(1)`).text())
  let maxId=Number($(`#StaTable tbody>tr:nth-child(${tbodyRowCount}) >td:nth-child(1)`).text())
  let ptidP1=rec[0]+1
  let nrowIdx=-1
  //if (ptidP1>=tbodyRowCount){
  if (!ForceAppend){
    if (ptidP1>tbodyRowCount){ ptidP1=tbodyRowCount} 
    if ( rec[0] > maxId ){
      nrowIdx=-1
    }else if (rec[0]<minId){ 
      nrowIdx=0
    }else{
      for (let tmpRowid=ptidP1; tmpRowid>0; tmpRowid--){
        let tmpId=Number($(`#StaTable tbody>tr:nth-child(${tmpRowid}) >td:nth-child(1)`).text())
        if (tmpId<rec[0]){ 
          nrowIdx=tmpRowid;
          break;
        }
      }
    }
  }
  let row = demoT.insertRow(nrowIdx);
  let cell0 = row.insertCell(0);
  let cell1 = row.insertCell(1);
  let cell2 = row.insertCell(2);
  let cell3 = row.insertCell(3);
  let cell4 = row.insertCell(4);
  let cell5 = row.insertCell(5); //modified by cywhale SL
  cell0.innerHTML=rec[0];
  cell0.setAttribute("style","color:#ccc;");
  let Div1=document.createElement('div');
  Div1.setAttribute("contenteditable","true");
  //Div1.setAttribute("id","Longitude");
  Div1.innerHTML=Number(rec[1]).toFixed(4);
  let Div2=document.createElement('div');
  Div2.setAttribute("contenteditable","true");
  //Div2.setAttribute("id","Latitude");
  Div2.innerHTML=Number(rec[2]).toFixed(4);
  var Div3=document.createElement('div');
  Div3.setAttribute("contenteditable","true");
  Div3.innerHTML=rec[3];
  var Div4=document.createElement('span');
  Div4.setAttribute("class","table-remove glyphicon glyphicon-remove" );
  Div4.onclick=function(e){
    let child=this.parentNode.parentNode; 
    let tparent=child.parentNode; 
    let ptid=child.cells[0].innerHTML
    tparent.removeChild(child); 
    removePointFromStaTable(ptid)
  };
  let Div5=document.createElement('div'); //modified by cywhale SL
  Div5.setAttribute("class","checkbox");
  Div5.setAttribute("id","showlabelchk");
  Div5.setAttribute("style","margin:0;");
  let div5chkid = "showlabelchk"+rec[0].toString();
  Div5.innerHTML= `<label><input type="checkbox" name="showlabelchk[]" value=${rec[0]} id=${div5chkid} checked="true" /></label>`;

  cell1.appendChild(Div1);
  cell2.appendChild(Div2);
  cell3.appendChild(Div3);
  cell4.appendChild(Div4);
  cell5.appendChild(Div5); //modified bycywhale SL
  $('#'+div5chkid).click(function() {onShowLabel(this)});

  $(row).mouseenter(function(){highlight(this,1)});
  $(row).mouseleave(function(){highlight(this,2)});
  $(cell0).click(function(){zoomInMap2depth(rec[1],rec[2])});
  $(Div1).blur(function(){
    let tmprec=[rec[0],rec[1],rec[2],rec[3],rec[4]]
    this.innerHTML=convertGPS(this.innerHTML);
    let tmplon=Number(this.innerHTML)
    if (isNaN(tmplon) || tmplon >360 || tmplon <-180){
      alert('longitude is not a valid number or out of range')
      this.innerHTML=rec[1].toString();
      selectText(this);
    }

    if (rec[1].toFixed(4)!==this.innerHTML){
      tmprec[1]=Number(this.innerHTML);
      for (let i=1; i<gvar.cPlanJSON.points.length; i++){
        if (gvar.cPlanJSON.points[i] && gvar.cPlanJSON.points[i][0]==tmprec[0]){
          gvar.cPlanJSON.points[i]=tmprec;
          rec=tmprec;
          break;
        }
      }
      Rec2Feature(tmprec);
      plotPointFromStaTable()
      if (ptInSchTable(rec[0])) {
        //不進行版本控制，而是自動重製
        plotLineFromSchTable()
      }
    }
  })
  $(Div1).keydown(function(e){
    if (e.keyCode == 13){
      // 下面這行很奇怪，如果用tmprec=rec(變成傳址呼叫
      // 亦即改tmprec會同時改rec，然後還導致版本控制裏的資料
      let tmprec=[rec[0],rec[1],rec[2],rec[3],rec[4]]
      this.innerHTML=convertGPS(this.innerHTML);
      let tmplon=Number(this.innerHTML)
      if (isNaN(tmplon) || tmplon >360 || tmplon <-180){
        alert('longitude is not a valid number or out of range')
        this.innerHTML=rec[1].toString();
        this.click();
        e.returnValue = false;
        return false;
      }
      if (rec[1].toFixed(4)!==this.innerHTML){
        //tmprec[1]=parseFloat(this.innerHTML);
        tmprec[1]=Number(this.innerHTML);
        for (let i=1; i<gvar.cPlanJSON.points.length; i++){
          if (gvar.cPlanJSON.points[i] && gvar.cPlanJSON.points[i][0]==tmprec[0]){
            gvar.cPlanJSON.points[i]=tmprec;
            rec=tmprec; 
            break;
          }
        }
        Rec2Feature(tmprec);
        plotPointFromStaTable();
        if (ptInSchTable(tmprec[0])) {
          //不進行版本控制，而是自動重製
          plotLineFromSchTable()
        }
      }
      var $this=$(this)
      let NcellIdx=$this.parent()[0].cellIndex+2;
      let Nobj=$this.parent().parent().find(`td:nth-Child(${NcellIdx}) > div`)
      Nobj.click();
      selectText(Nobj.get(0));
      e.returnValue = false;
      return false;
    }
  })
  $(Div2).blur(function(){
    let tmprec=[rec[0],rec[1],rec[2],rec[3],rec[4]]
    this.innerHTML=convertGPS(this.innerHTML);
    let tmplat=Number(this.innerHTML)
    if (isNaN(tmplat) || tmplat >90 || tmplat <-90){
      alert('latitude is not a valid number or out of range')
      this.innerHTML=rec[2].toFixed(4);
      selectText(this);
    }
    if (rec[2].toFixed(4)!==this.innerHTML){
      tmprec[2]=Number(this.innerHTML);
      for (let i=1; i<gvar.cPlanJSON.points.length; i++){
        if (gvar.cPlanJSON.points[i] && gvar.cPlanJSON.points[i][0]==tmprec[0]){
          gvar.cPlanJSON.points[i]=tmprec;
          rec=tmprec; 
          break;
        }
      }
      Rec2Feature(tmprec);
      plotPointFromStaTable();
      if (ptInSchTable(rec[0])) {
        //不進行版本控制，而是自動重製
        plotLineFromSchTable()
      }
    }
  })
  $(Div2).keydown(function(e){
    if (e.keyCode == 13){
      let tmprec=[rec[0],rec[1],rec[2],rec[3],rec[4]]
      this.innerHTML=convertGPS(this.innerHTML);
      let tmplat=Number(this.innerHTML)
      if (isNaN(tmplat) ||  tmplat >90 || tmplat <-90){
        alert('latitude is not a valid number or out of range')
        this.innerHTML=rec[2].Fiexed(4);
        selectText(this);
      }
      if (rec[2].toFixed(4)!==this.innerHTML){
        tmprec[2]=Number(this.innerHTML);
        for (let i=1; i<gvar.cPlanJSON.points.length; i++){
          if (gvar.cPlanJSON.points[i] && gvar.cPlanJSON.points[i][0]==tmprec[0]){
            gvar.cPlanJSON.points[i]=tmprec;
            rec=tmprec; 
            break;
          }
        }
        Rec2Feature(tmprec);
        plotPointFromStaTable();
        if (ptInSchTable(rec[0])) {
          //不進行版本控制，而是自動重製
          plotLineFromSchTable()
        }
      }
      var $this=$(this)
      let NcellIdx=$this.parent()[0].cellIndex+2;
      $this.parent().parent().find(`td:nth-Child(${NcellIdx}) > div`).click()
      e.returnValue = false;
      return false;
    }
  })
  $(Div3).blur(function(){
    let tmprec=[rec[0],rec[1],rec[2],rec[3],rec[4]]
    if (rec[3].toString()!==this.innerHTML){
      tmprec[3]=this.innerHTML;
      for (let i=1; i<gvar.cPlanJSON.points.length; i++){
        if (gvar.cPlanJSON.points[i] && gvar.cPlanJSON.points[i][0]==tmprec[0]){
          gvar.cPlanJSON.points[i]=tmprec;
          rec=tmprec; 
          break;
        }
      }
      Rec2Feature(tmprec);
    }
  })
  $(Div3).keydown(function(e){
    if (e.keyCode == 13){
      let tmprec=[rec[0],rec[1],rec[2],rec[3],rec[4]]
      if (rec[3].toString()!==this.innerHTML){
        tmprec[3]=this.innerHTML;
        for (let i=1; i<gvar.cPlanJSON.points.length; i++){
          if (gvar.cPlanJSON.points[i] && gvar.cPlanJSON.points[i][0]==tmprec[0]){
            gvar.cPlanJSON.points[i]=tmprec;
            rec=tmprec; 
            break;
          }
        }
        Rec2Feature(tmprec);
      }
      var $this=$(this)
      let nextRow=$this.closest('tr').next();
      let cellIdx=$this.parent()[0].cellIndex;
      if ($this.closest('tr').next().length>0){
        $this.closest('tr').next().eq(0).find('td').eq(`${cellIdx}`).find('div').click()
      }
      e.returnValue = false;
      return false;
    }
  })
  $(Div3).click(function(){selectText(this)})
}
function ptInSchTable(ptid){
  if ($(`#SchTable tbody tr td:nth-child(1)`).filter(`:contains(${ptid})`).parent().index() < 0) {
  return false
  }
  return true
}
function Rec2Feature(rec){
  let coord = OlProjTransform([rec[1],rec[2]],'EPSG:4326','EPSG:3857');
  let olitem=gvar.olpointsOverlay.getSource().getFeatureById(rec[0]);
  olitem.getGeometry().setCoordinates(coord);
  let olitemProp=olitem.getProperties();
  olitemProp.name=rec[3];
  olitemProp.inLine=rec[4];
  olitem.setProperties(olitemProp);
}
function StaTblRow2Feature(ptId){
  let rec=[] /* rec=[id,strlon,strlat,name]*/
  let tmprow=$(`#StaTable tbody tr td:nth-child(1)`).filter(`:contains(${ptId})`).parent()
  rec[0]=tmprow.find('td').eq(0).text();
  rec[1]=parseFloat(tmprow.find('td').eq(1).text());
  rec[2]=parseFloat(tmprow.find('td').eq(2).text());
  rec[3]=tmprow.find('td').eq(3).text();
  rec[4]=0;
  Rec2Feature(rec);
  /*let coord = OlProjTransform([rec[1],rec[2]],'EPSG:4326','EPSG:3857');
  let olitem=gvar.olpointsOverlay.getSource().getFeatureById(ptId);
  //console.log(olitem);
  olitem.getGeometry().setCoordinates(coord);
  //console.log('abv');
  let olitemProp=olitem.getProperties();
  //console.log('abve');
  //statable only has site name for properties
  olitemProp.name=rec[3];
  olitem.setProperties(olitemProp);*/
}
function Feature2record(item){
  let rec=[] /* rec=[id,strlon,strlat,name]*/
  let geometry = item.getGeometry();
  let coord = geometry.getCoordinates();
  rec[0] = item.getProperties()['id'];
  rec[3] = item.getProperties()['name'];
  coord = OlProjTransform(coord, 'EPSG:3857', 'EPSG:4326');
  rec[1]=Number(coord[0].toFixed(4));
  rec[2]=Number(coord[1].toFixed(4));
  if (item.getProperties()['inLine']!=undefined){
    rec[4]=item.getProperties()['inLine']
  }else{
    rec[4]=1;
  }
  //if ($('#ChkAutoLine').prop('checked')){
  //  rec[4]=0;
  //} 
  return rec
}
function getInLineVal(){
}
function Feature2StaTblRow(chkVC,item,index){
// 注意，chkVC=true則進行版本控，false則否
// 直接執行這個函數時，參數為chkVC, item, index
// 透過forEach執行時，則Feature2StaTblRow(null,chkVC)
    let StaTableId="StaTable";
    let rec=Feature2record(item);
    var tmpchk=true
    for (let i=1; i<gvar.cPlanJSON.points.length; i++){
      if (gvar.cPlanJSON.points[i] && gvar.cPlanJSON.points[i][0]==index){
        if (chkVC){
          gvar.cPlanJSON.points[i]=rec;
        }
        tmpchk=false;
        modifyStaTable(StaTableId,rec)
        //console.log(rec)
        break;
      }
    }
    if (tmpchk){
      appendStaTable(StaTableId,rec);
      if (chkVC){
        gvar.cPlanJSON.points.push(rec);
      }
    }
    return rec
};
function highlightTPtrack(lon,lat,m){
  var url='/odbintl/wfs/typhoontrack/?';
  url+='lonlat='+lon.toString()+','+lat.toString();
  url+='&rdis=0.25&data=tpinfo';
  $.getJSON(url, function (jsondata){
    map.getLayers().forEach(function(layer){ 
      if (layer.get('name') =='TyphoonTracks'){
        //console.log(gvar.HighlightTPtracks)
        for (let i=0; i< gvar.HighlightTPtracks.length;i=i+1){
          let tpid=gvar.HighlightTPtracks[i];
          var tmpfeature=layer.getSource().getFeatureById(tpid)
          tmpfeature.setStyle(new OlStyleStyle({
            stroke: new OlStyleStroke({
              color:'rgba(155,155,255,0.3)',
              width: 1
            })
          }))
        } 
        var tmpcontent='';
        var typurl='https://rdc28.cwb.gov.tw/TDB/public/typhoon_detail?typhoon_id='
        for (let i=0; i < jsondata.tpid.length; i=i+1){
          var tpid=jsondata.tpid[i];
          tmpcontent+='<a href='+typurl+tpid.toString() ;
          tmpcontent+=' class="btn-xs btn-primary d-inline" role="button" target="_blank">';
          tmpcontent+=Math.floor(tpid/100).toString();
          tmpcontent+=jsondata.cht_name[i]+'</a>';
          var tmpfeature=layer.getSource().getFeatureById(tpid)
          tmpfeature.setStyle(new OlStyleStyle({
          stroke: new OlStyleStroke({
            color:'rgba(15,205,115,0.7)',
            width: 2
          })
        }))
        $('#info2show').html(tmpcontent);
        /*var tmpfeature=layer.getSource().getFeatureById(tpid)
          tmpfeature.setStyle(new OlStyleStyle({
            stroke: new OlStyleStyle({
              color:'rgba(155,155,255,0.3)',
              width: 1
            })
          }))*/
      }
    }
    })
        gvar.HighlightTPtracks = jsondata.tpid;
  })
}
function highlight(x,m){
  if (m === undefined){
    m=1;
  }
  if (x.rowIndex>0){
    //var ptID=parseInt(x.cells[0].innerText);
    var ptID=x.rowIndex-1;
    var tmpfeatures=gvar.pt4highlight.getSource().getFeatures();
    if (m==1){
      if ($('#isTyphoonTracksSelected').is(":checked")){
        highlightTPtrack(parseFloat(x.cells[1].innerText), parseFloat(x.cells[2].innerText));

      }
      gvar.olpointsOverlay.getSource().getFeatures()[ptID].setStyle(highlightStyleFunction);
    }else{
      gvar.olpointsOverlay.getSource().getFeatures()[ptID].setStyle(gvar.olstyleFunction);
    }
  }
}
function selectText(obj) {      // adapted from Denis Sadowski (via StackOverflow.com)
  obj.scrollIntoView({block:"nearest"});
  if (document.selection) {
    var range = document.body.createTextRange();
      range.moveToElementText(obj);
      range.select();
    }
  else if (window.getSelection) {
    var range = document.createRange();
      if (obj.firstChild){
        range.selectNode(obj.firstChild);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
  }
}
function animateHighlight(obj,highlightColor,duration){
  var notLocked=false;
  var highlightBg = highlightColor || "rgb(255, 255, 156)";
  var animateMs = duration || 1000;
  var originalBg = obj.css("backgroundColor") ;
  let rgb1=highlightBg.replace(/[^\d,]/g, '').split(',')
  let rgb2=originalBg.replace(/[^\d,]/g, '').split(',')
  if (rgb1[0]+rgb1[1]+rgb1[2]!=rgb2[0]+rgb2[1]+rgb2[2]){
    notLocked=true 
  };
  if (notLocked) {
    notLocked = false;
    obj.stop().css("backgroundColor", highlightBg)
      .animate({"background-color": originalBg}, animateMs);
    setTimeout( function() { 
      obj.css("backgroundColor", originalBg)
    }, animateMs+100);
  }
}
function setRemoveButtonInStaTable(){
  var demoT=document.getElementById("StaTable");
  var schT=document.getElementById("SchTable");
  var SchIds=[];
  if (schT.rows.length > 1 ) {
    for ( let i = 1; i < schT.rows.length; i++ ) {
      SchIds.push(parseInt(schT.rows[i].cells[0].textContent));
    }
    if ( demoT.rows.length > 1 ) {
      for ( let i = 1; i < demoT.rows.length; i++ ) {
        if (SchIds.indexOf(parseInt(demoT.rows[i].cells[0].textContent))>=0) {
          demoT.rows[i].cells[4].getElementsByTagName("span")[0].classList.add('hidden');
        }else{
          demoT.rows[i].cells[4].getElementsByTagName("span")[0].classList.remove('hidden');
        }
      }
    }
  }
}
function convertGPS(StrIn){
  let tmp1 =StrIn.toLowerCase().split('d');
  let StrOut=StrIn;
  //console.log(StrIn, tmp1);
  if (tmp1.length==1){
    StrOut=tmp1[0]
  }else if (tmp1.length==2){
    let tmp2 =tmp1[1].toLowerCase().split('m');
    if (tmp2.length==1){
      StrOut=tmp1[0]*1+tmp1[1]/60;
      //console.log('a')
    }else if (tmp2.length==2){
      StrOut=tmp1[0]*1+tmp2[0]/60+tmp2[1]/3600;
      //console.log('b')
      //console.log("Output", StrOut)
    }else {
      StrOut=tmp1[0];
      //console.log('c')
    }
  }
  StrOut=Number(StrOut);
  if (isNaN(StrOut)){
    return StrOut
  }else{
    return StrOut.toFixed(4);
  }
}

function removePointFromStaTable(rowid){
  const demoT=document.getElementById("StaTable");
  if (demoT.rows.length > 0 ) {
    //let ids=[];
    //// first row (i=0) of StaTable is head, start from 1
    //for ( let i = 1; i < demoT.rows.length; i++ ) {
    //  ids.push(parseInt(demoT.rows[i].cells[0].textContent));
    //}
   //console.log(rowid)
    let tmpObj=gvar.olpointsOverlay.getSource().getFeatureById(rowid)
    let rec=Feature2record(tmpObj)
    gvar.olpointsOverlay.getSource().removeFeature(tmpObj);
    //gvar.points = gvar.olpointsOverlay.getSource().getFeatures();
//    for ( let i = 0; i < gvar.cPlanJSON.points.length; i++ ) {
//      if (gvar.cPlanJSON.points[i] && gvar.cPlanJSON.points[i]==rowid){
//      i
//      }
//    }
    let tmpid=gvar.cPlanJSON.points.reduce((a,b,c)=>(b&&b[0]==rowid)? a=c:a=a,-1)
    //gvar.cPlanJSON.points.splice(tmpid,1) //can not be used in Version Control
    //delete gvar.cPlanJSON.points[tmpid]
    rec[0]=-1
    gvar.cPlanJSON.points[tmpid]=rec
    //gvar.cPlanJSON.points[tmpid][0]=-1
    //console.log(ids)
    //console.log(ids.length)
    /*for ( let i = 0; i < gvar.points.length; i++ ) {
      //console.log(gvar.points[i].getProperties().id);
      //console.log(ids.indexOf(gvar.points[i].getProperties().id));
      if (ids.indexOf(gvar.points[i].getProperties().id)<0 ) {
        gvar.olpointsOverlay.getSource().removeFeature(gvar.points[i]);
      }
    }*/
  }
}
function plotPointFromStaTable(){
  if (document.getElementById("chkShowSiteName")){
    gvar.chkShowSiteName=document.getElementById("chkShowSiteName").checked;
  }else{
    return false
  }
  var pointsSource=gvar.olpointsOverlay.getSource();
  gvar.points = pointsSource.getFeatures();
  var StaT=document.getElementById("StaTable");
  //gvar.StaData.point=[];
  //gvar.StaData.point.push(["ID","Longitude","Latitude","Name","inLine"]);
  if (StaT.rows.length > 1 ) {
    for ( let i = 1; i < StaT.rows.length; i++ ) {
      let tmpid=parseInt(StaT.rows[i].cells[0].textContent);
      let ididx=i-1;
      let lon=parseFloat(convertGPS(StaT.rows[i].cells[1].textContent));
      let lat=parseFloat(convertGPS(StaT.rows[i].cells[2].textContent));

      let siteshowchk=StaT.rows[i].cells[5].firstChild.firstChild.firstChild.checked; //modified by cywhale SL

      let ptid=parseInt(convertGPS(StaT.rows[i].cells[0].textContent));
      if (isNaN(lon)){
        lon=0.0;
        StaT.rows[i].cells[1].childNodes[0].innerHTML=lon;
      }
      if (isNaN(lat)){
        lat=0.0;
        StaT.rows[i].cells[2].childNodes[0].innerHTML=lat;
      }
      let sitename=siteshowchk? StaT.rows[i].cells[3].textContent : ""; //modified by cywhale SL
      let PTinLine=1;
      let tmpc4=StaT.rows[i].cells[4];
      let tmpPt=pointsSource.getFeatureById(ptid);
      if (tmpPt.getProperties().inLine != undefined){
        PTinLine=tmpPt.getProperties().inLine;
      }
      if (tmpc4 != undefined){
        if (tmpc4.innerHTML.indexOf('hidden')>=0){
          PTinLine=0;
        }
      }
      let coord=(OlProjTransform([lon,lat], 'EPSG:4326', 'EPSG:3857'));
      tmpPt.setId(ptid);
      tmpPt.setProperties({
        'ID': siteshowchk? ptid.toString() : "", //modified by cywhale SL
        'name': sitename,
        //'staHr': stayhr,
        'inLine':PTinLine,
        //'workItem':workItem
      });
      tmpPt.getGeometry().setCoordinates(coord);
      //gvar.StaData.point.push([tmpid,lon,lat,sitename,PTinLine]);
    }; 
  };
  return true
};
function plotLineFromSchTable(){
  var demoT=document.getElementById("StaTable");
  //var schT=document.getElementById("SchTable");
  var schT=document.getElementById("SchTable").getElementsByTagName('tbody')[0];
  var totDis=0.0;
  var totHrs=0.0;
  var tmpa=gvar.cplanlinesource.getFeatures();
  if(tmpa.length>0){
    for ( let i = 0; i < tmpa.length; i++ ) {
      gvar.cplanlinesource.removeFeature(tmpa[i]);
    };
  };
  if (demoT.rows.length > 1 ) {
    var pts=[];
    var names=[];
    var stids=[];
    for ( let i = 1; i < demoT.rows.length; i++ ) {
      var stid=demoT.rows[i].cells[0].textContent;
      var lon=parseFloat(convertGPS(demoT.rows[i].cells[1].textContent));
      var lat=parseFloat(convertGPS(demoT.rows[i].cells[2].textContent));
      pts.push(OlProjTransform([lon,lat], 'EPSG:4326', 'EPSG:3857'));
      names.push(demoT.rows[i].cells[3].textContent);
      stids.push(stid);
    };
    var linepts=[];
    gvar.SchData.line=[];
    if (schT.rows.length > 0 ) {
      gvar.SchData.line.push(gvar.SchData.lineHead);
      for ( let tmpj = 0; tmpj < schT.rows.length; tmpj++ ) {
        let j=tmpj;
        let stayhr=parseFloat(schT.rows[j].cells[4].childNodes[0].textContent);
        let workItem=schT.rows[j].cells[5].childNodes[0].getAttribute("wkdata");
        if (workItem=="{'item':['PT'],'other':''}"){
          workItem='{"item":["PT"],"other":""}'
        }
        if (isNaN(stayhr)){
          stayhr=0.0;
        }
        let tmpid=schT.rows[j].cells[0].textContent;
        let chkline=0;
        var shipspd=0;
        for ( let i=0; i < stids.length; i++) {
          if ( tmpid == stids[i]){
            linepts.push(pts[i]);
            if (linepts.length > 1) {
              let coord0 = OlProjTransform(linepts[linepts.length-2], 'EPSG:3857', 'EPSG:4326');
              let coord = OlProjTransform(linepts[linepts.length-1], 'EPSG:3857', 'EPSG:4326');
              let dis=OlSphereGetDistance(coord0, coord)/1.852/1000;
              totDis=totDis+dis;
              schT.rows[j].cells[1].innerHTML=dis.toFixed(1);
              let hrs=parseFloat(schT.rows[j].cells[3].childNodes[0].textContent)
              let shipspd=parseFloat(schT.rows[j].cells[2].textContent)
              if (isNaN(shipspd) || shipspd==0) {shipspd=8.0}
              if (isNaN(hrs)) {gvar.chkShipSpdByHrs=false}
              if (gvar.chkShipSpdByHrs){
                shipspd=dis/hrs;
                shipspd=Number(shipspd.toFixed(1));
              }else{
                shipspd=parseFloat(schT.rows[j].cells[2].textContent)
                if (isNaN(shipspd)){ shipspd=8.0; }
                hrs=dis/shipspd;
                hrs=Number(hrs.toFixed(1));
              }
              if (dis<0.000001 ){
                shipspd=8.0;hrs=0.0
              }

              schT.rows[j].cells[2].childNodes[0].innerHTML=shipspd.toFixed(1);
              schT.rows[j].cells[3].childNodes[0].innerHTML=hrs.toFixed(1);
              switch (true){
                case (shipspd>20):
                  $(schT.rows[j].cells[2]).addClass("bg-danger text-white");
                  $(schT.rows[j].cells[2]).removeClass("text-danger")
                  $(schT.rows[j].cells[2]).removeClass("text-primary")
                  break;
                case (shipspd>15):
                  $(schT.rows[j].cells[2]).addClass("text-danger")
                  $(schT.rows[j].cells[2]).removeClass("bg-danger text-white");
                  $(schT.rows[j].cells[2]).removeClass("text-primary")
                  break;
                case (shipspd>12):
                  $(schT.rows[j].cells[2]).addClass("text-primary")
                  $(schT.rows[j].cells[2]).removeClass("bg-danger text-white");
                  $(schT.rows[j].cells[2]).removeClass("text-danger")
                  break;
                default:
                  $(schT.rows[j].cells[2]).removeClass("bg-danger text-white");
                  $(schT.rows[j].cells[2]).removeClass("text-danger")
                  $(schT.rows[j].cells[2]).removeClass("text-primary")
                  break;
              }
              switch (true){
                case (hrs>96):
                  $(schT.rows[j].cells[3]).addClass("text-danger");
                  break;
                case (hrs>48):
                  $(schT.rows[j].cells[3]).addClass("text-warning");
                  break;
                default:
                  $(schT.rows[j].cells[3]).removeClass("text-danger");
                  $(schT.rows[j].cells[3]).removeClass("text-warning");
                  break; 
              }
              gvar.SchData.line.push([tmpid,dis,shipspd,hrs,stayhr,workItem]);
              totHrs=totHrs+hrs+stayhr;
              chkline=1;
            }else{
              schT.rows[j].cells[1].innerHTML="";
              schT.rows[j].cells[2].childNodes[0].innerHTML="8.0";
              schT.rows[j].cells[3].childNodes[0].innerHTML="";
              gvar.SchData.line.push([tmpid,'','','',stayhr,workItem]);
            };
          };
        };
      };
      var cruisestatic=document.getElementById("cruisestatics");
      cruisestatic.innerHTML="總距離:"+totDis.toFixed(1)+"nm; 全程時間約:"+totHrs.toFixed(1)+"小時";
      tmpa=gvar.cplanlinesource.getFeatures();
      if(tmpa.length>0){
        for ( i = 0; i < tmpa.length; i++ ) {
          gvar.cplanlinesource.removeFeature(tmpa[i]);
        };
      };
      var featurethings=[];
      for ( let i = 1; i < linepts.length; i++ ) {
        let thing = new OlGeomLineString([linepts[i-1],linepts[i]]);
        let featurething = new OlFeature({
          name:"",// names[i]+'nm',
          geometry: thing
        });
        gvar.cplanlinesource.addFeature( featurething );
      };
    };
  };
  setRemoveButtonInStaTable();
};
function erasePoints(){
  gvar.autoID+=1;
  iniStaTable();
  var pointsSource=gvar.olpointsOverlay.getSource()
  gvar.points = gvar.olpointsOverlay.getSource().getFeatures();
  if(gvar.points.length>0){
    //console.log(gvar.points);
    var tmpa=gvar.points.length;
    //console.log(gvar.points.length);
    for (let i = 0; i < tmpa; i++ ) {
      //console.log(i);
      //console.log(gvar.points[i]);
      pointsSource.removeFeature(gvar.points[0]);
    };
  };
}
function iniStaTable(){
  var demoT=document.getElementById("StaTable");
  while(demoT.rows.length > 0){
    demoT.deleteRow(0);
  };
  var header = demoT.createTHead();
  var row = header.insertRow(0);
  var cell0 = row.insertCell(0);
  var cell1 = row.insertCell(1);
  var cell2 = row.insertCell(2);
  var cell3 = row.insertCell(3);
  var cell4 = row.insertCell(4);
  var cell5 = row.insertCell(5); //modified by cywhale ShowLabel(SL) 20210519
  cell0.innerHTML="ID";
  cell1.innerHTML="Longitude";
  cell2.innerHTML="Latitude";
  if (gvar.chkShowSiteName){
    cell3.innerHTML='<label>Name <input type="checkbox" id="chkShowSiteName" checked style="margin:0;"  data-toggle="tooltip" data-placement="top" title="Show Name or ID 畫出各點名稱或ID"></label>';
  }else{
    cell3.innerHTML='<label>Name <input type="checkbox" id="chkShowSiteName" style="margin:0;"  data-toggle="tooltip" data-placement="top" title="Show Name or ID 顯示各點名稱或ID"></label>';
  }
  cell4.innerHTML=`<div class="glyphicon glyphicon-remove-circle" data-toggle="tooltip" data-placement="top" title="Delete site 刪除該點!"/>`; //"" modified by cywhale
  cell5.innerHTML=`<div id="toggShowLabel" value="true" class="glyphicon glyphicon-eye-open" data-toggle="tooltip" data-placement="top" title="Label On/Off 是否顯示各點名稱"></div>`; //modified by cywhale SL
  $('#StaTable').find('#chkShowSiteName').click(function(){plotPointFromStaTable()})
  if (document.getElementById('StaTable').getElementsByTagName('tbody').length==0){
    let TBody = demoT.createTBody();
  }
  $('#toggShowLabel').click(function(){ //modified by cywhale SL
    let val = $(this).val();
    if (val) {
      $(this).attr('class','glyphicon glyphicon-eye-close');
    } else {
      $(this).attr('class','glyphicon glyphicon-eye-open');
    }
    $("input:checkbox[name^='showlabelchk']").each(function(){ //:checked //:not(:checked)
       $(this).prop('checked', !val)
    });
    $(this).val(!val);
    plotPointFromStaTable();
  });
};
function setWorkItemClass(cellx){
  if (document.getElementById("setWorkItem").checked){
    cellx.setAttribute("class","workItem");
  }else{
    cellx.setAttribute("class","workItem hide");
  }
}
function buildwkItemSelect(ObjId,wkItem){
  var tmpstr=''
    tmpstr+='<form class="form-inline" >'
  Object.keys(gvar.wkItem).forEach(function(key) {
    if(key !== 'PT'){
      tmpstr+='<div style="white-space:nowrap">'
      tmpstr+='<input type="checkbox" id="'+ key +'" name="' + key +'"/>'
      tmpstr+='<label class="checkbox" for="' + key + '">'
      tmpstr+=gvar.wkItem[key][1]+'；</label>'
      if (key=='O'){
          tmpstr+='<input type="text" class="text-inline" placeholder="請輸入自訂工作項目" id="otherO"/>'
      }else{
        tmpstr += '&nbsp';
      }
      tmpstr+='</div>'
    }
  })
    tmpstr+='<button type="button" class="btn btn-primary btn-xs" id="WkItemFormBtn">完成</button>'
    tmpstr+='</form>'
  return(tmpstr)
}
function dontSubmit (event)
{
   if (event.keyCode == 13) {
      return false;
   }
}
function buildWorkItem(ObjId,swkItem){
  if (typeof swkItem === 'string') {
    var wkItem=JSON.parse(swkItem);
  }else{
    var wkItem=swkItem;
  }
  let cellobj=document.getElementById(ObjId)
  //console.log(ObjId)
  $(cellobj.childNodes[0]).popover({
    html: true,
    title: '<span>請選擇站點工作項目</span><button id="popovercloseid" type="button" class="close">&times;</button>',
    content:buildwkItemSelect(ObjId,wkItem),
    container:'body',
    trigger:'manual',
    placement:'auto'
  }).popover('show')
  $('#popovercloseid').click(function(){
    unfreezeScreen();
  })
  $('#WkItemFormBtn').click(function(){
    saveWkItem(this,ObjId);
    unfreezeScreen();
    document.getElementById('popovercloseid').click();
  })
  $('#otherO').keypress(function(event){
    return dontSubmit(event);
  })
  Object.keys(gvar.wkItem).forEach(function(key) {
    if(key !== 'PT'){
      if (wkItem['item'].indexOf(key) >-1) {
       document.getElementById(key).checked=true;
      }
      if (key=='O'){
        document.getElementById('other'+key).value=wkItem['other'];
      }
    }
  })

  let x = document.getElementById('freeze-screen');
  x.classList.remove("hide");
}
function saveWkItem(tmpobj,cellObjId){
  var cellObj=document.getElementById(cellObjId)
  var tmpitem=[]
  var tmpother=''
  var obj=tmpobj.parentNode
  if (obj.elements["other"+"O"].value.length>0){
    tmpother=obj.elements["other"+"O"].value;
    if ( ! obj.elements["O"].checked){
    tmpitem.push("O");
    };
  }else{
    obj.elements["O"].checked=false
  };
  Object.keys(gvar.wkItem).forEach(function(key) {
    if (key !== "PT"){
      if (obj.elements[key].checked){
        tmpitem.push(key);
      }
    }
  })
  if (tmpitem.length==0){
    tmpitem.push("PT");
  }
  var tmpwkItem={"item":tmpitem,"other":tmpother}
  let strWkItem=JSON.stringify(tmpwkItem);
  let OldWkItem=cellObj.childNodes[0].childNodes[0].innerHTML;
  let NewWkItem=workItem2show(strWkItem);

  cellObj.childNodes[0].childNodes[0].innerHTML=NewWkItem;
  //cellObj.childNodes[0].childNodes[0].innerHTML=workItem2show(strWkItem);
  cellObj.childNodes[0].setAttribute("wkdata",strWkItem);
  //cellObj.setAttribute("onclick","buildWorkItem('"+cellObjId+"',"+strWkItem +")");
  $(cellObj).click(function(){
    buildWorkItem(cellObjId,strWkItem);
  })
  
  if (OldWkItem!=NewWkItem){
    //plotLineFromSchTable()
    //gvar.cPlanJSON.line=gvar.SchData.line
    $.when(plotLineFromSchTable()).then(function(){
      gvar.cPlanJSON.line=gvar.SchData.line;
    });
  }
}
export function changeMapSize(mapId,strMapShape,MapExtent){
  let strW;
  let strH;
  let wh=strMapShape.split(',');
  if (wh.length==2){
    strW=wh[1]+'px';
    strH=wh[0]+'px';
  }else{ 
    if (strMapShape=='9to16'){
      strW='700px';
      strH='400px';
    }else if (strMapShape=='16to9'){
      strW='400px';
      strH='700px';
    }else if (strMapShape=='fullfill'){
      strW='100%';
      strH='100%';
    }else{
      strW='700px';
      strH='700px';
    }
  }
  var obj=document.getElementById(mapId);
  obj.style.height=strW;
  obj.style.width=strH;
  //console.log(['strwh',strW,strH])
  jamie()
  gvar.map.updateSize();
  //gvar.map.renderSync();
  if (MapExtent !== undefined){
  gvar.map.once('rendercomplete',function(){
    let tmpextent=MapExtent.split(',');
    //console.log(tmpextent)
    gvar.map.getView().fit(tmpextent);
  })
  }
}
function jamie(){
	var callerName;
	try {
       	    throw new Error();
	}catch(e){
	    var re = /(\w+)@|at (\w+) \(/g, st = e.stack, m;
	    re.exec(st), m = re.exec(st);
	    callerName = m[1] || m[2];
	}
	//console.log(callerName);
};

function unfreezeScreen(){
  var x = document.getElementById('freeze-screen');
  x.classList.add("hide");
}
export function rdCanvas2ImgArr(){
  let dataURL;
  let nmap2=$('#map2').data('map');
  let map2Size=nmap2.getSize();
  let map2Extent=nmap2.getView().calculateExtent();
  if (gvar.updateImgArrIdx<0){
  //if (idx === undefined){
    gvar.imgMapArr.push(new Image());
    var idx=gvar.imgMapArr.length-1;
    gvar.imgMapArr[idx].width=parseInt(map2Size[0]/700*200);
  }else{
    var idx=gvar.updateImgArrIdx;
  }

  gvar.tmpNr+=1;
  gvar.imgMapArr[idx].setAttribute("id","img_"+gvar.tmpNr);
  //setTimeout(function(){
    //dataURL = $('canvas').get(0).toDataURL("image/png");
    dataURL = Map2DataUrl();
    gvar.imgMapArr[idx].src=dataURL;
  //  },
  //  250
  //)
  gvar.imgMapArr[idx].setAttribute("data-mapSize",map2Size);
  gvar.imgMapArr[idx].setAttribute("data-mapExtent",map2Extent);

/* 20210704 modified by cywhale: add a function that can publish A4-size img in pdf (A4-need)*/
  gvar.imgMapArr[idx].a4need = $('#gen_a4pic_chk').prop('checked');
  //console.log("Set A4-need attr:", gvar.imgMapArr[idx].a4need);

  //console.log(map2Extent)
  var imgs4pdfObj=$('#imgs4pdf');
  if (gvar.updateImgArrIdx<0) {
    //var tmpImg=document.createElement("IMG");
    gvar.imgMapArr[idx].setAttribute("class","img-thumbnail");
    //gvar.imgMapArr[idx].setAttribute("onclick","javascript:gvar.updateImgArrIdx="+idx.toString()+";$('#mapModal').modal();");
    gvar.imgMapArr[idx].setAttribute("id","img_"+gvar.tmpNr);
    gvar.imgMapArr[idx].setAttribute("data-mapSize",map2Size);
    gvar.imgMapArr[idx].setAttribute("data-mapExtent",map2Extent);
    //tmpImg.setAttribute("src",gvar.imgMapArr[idx]);
    imgs4pdfObj.append(gvar.imgMapArr[idx]);
    //jQuery(document).ready(function($){
      let a='<span class="closebtn" style="margin:2px;cursor:pointer">&times;</span>';
      $('#img_'+gvar.tmpNr).after(a)

      //A4-need
      if ($('#gen_a4pic_chk').prop('checked')) {
         let b='<span class="a4needico glyphicon glyphicon-resize-full" id="a4needico' + idx + '" ' +
               'style="font-size:16px;cursor:pointer;margin-left:-20px;margin-right:5px;color:red;" '+
               'data-toggle="tooltip" data-placement="top" title="Generate A4-size image in PDF 製作PDF時產生此A4-size圖檔"></span>'
         $('#img_'+gvar.tmpNr).after(b)
      }

      setCloseBtnInteraction();
      setSubImgClick();
      $('#gen_a4pic_chk').prop('checked', false);
    //})
  }
  //return imgArray
}
/*
function rdCanvas2Img(imgID){
  setTimeout(function(){
    var dataURL = $('canvas').get(0).toDataURL("image/png");
    document.getElementById(imgID).setAttribute(
      'src',dataURL
     ),2000
  })
}
*/

function chRightPanelSize(){
  var tmpObj=document.getElementById("RightPanel");
  var tmpObj2=document.getElementsByClassName("workItem");
  if (document.getElementById("setWorkItem").checked){
    tmpObj.classList.remove("col-md-4")
    tmpObj.classList.add("col-md-6")
    for (let  i = 0; i < tmpObj2.length; i++) {
      tmpObj2[i].classList.remove("hide")
    }
    var demoT=document.getElementById("StaTable");
  }else{
    tmpObj.classList.remove("col-md-6")
    tmpObj.classList.add("col-md-4")
    for (let i = 0; i < tmpObj2.length; i++) {
      tmpObj2[i].classList.add("hide")
    }
  }
};
function genSchById() {
  var demoT=document.getElementById("SchTable");
  while(demoT.rows.length > 0){
    demoT.deleteRow(0);
  };
  var header = demoT.createTHead();
  var row = header.insertRow(0);
  var cell0 = row.insertCell(0);
  var cell1 = row.insertCell(1);
  var cell2 = row.insertCell(2);
  var cell3 = row.insertCell(3);
  var cell4 = row.insertCell(4);
  var cell5 = row.insertCell(5);
  var cell6 = row.insertCell(6);
  cell0.innerHTML="ID";
  cell1.innerHTML="距離";
  cell2.innerHTML="船速[節]";
  cell3.innerHTML="航時[hr]";
  cell4.innerHTML="作業時間";
  cell5.innerHTML="工作項目";
  var SPAN1=document.createElement('span');
  SPAN1.setAttribute("class","table-add glyphicon glyphicon-plus")
  SPAN1.onclick=function(e){SchTableAddRow()};
  cell6.appendChild(SPAN1);

  var TBody = demoT.createTBody();
  for ( var i =0; i< gvar.points.length; i++ ){
   //console.log(i)
    let tmpidx=gvar.points[i].getProperties().id;
    SchTableAddRow(tmpidx);
  }
 //setSchTableSortable();
 plotLineFromSchTable(); 
}
function setSchTableSortable(tableID,tmpThis){
  //console.log(tmpThis.checked)
  $('#'+ tableID + ' tbody').sortable({
    //change: function(event,ui){
    //  plotLineFromSchTable(); 
    //},
    disabled:! tmpThis.checked,
    update: function(event,ui){
      gvar.chkShipSpdByHrs=false;
      plotLineFromSchTable(); 
      gvar.cPlanJSON.line=gvar.SchData.line
    }
  });
}
function iniSchTable(){
  var demoT=document.getElementById("SchTable");
  while(demoT.rows.length > 0){
    demoT.deleteRow(0);
  };
  var header = demoT.createTHead();
  var row = header.insertRow(0);
  var cell0 = row.insertCell(0);
  var cell1 = row.insertCell(1);
  var cell2 = row.insertCell(2);
  var cell3 = row.insertCell(3);
  var cell4 = row.insertCell(4);
  var cell5 = row.insertCell(5);
  var cell6 = row.insertCell(6);
  cell0.innerHTML="ID";
  cell1.innerHTML="距離";
  cell2.innerHTML="船速[節]";
  cell3.innerHTML="航時[hr]";
  cell4.innerHTML="作業時間";
  cell5.innerHTML="作業項目";
  setWorkItemClass(cell5);
  var SPAN=document.createElement('span');
  SPAN.setAttribute("class","table-add glyphicon glyphicon-plus")
  SPAN.onclick=function(e){SchTableAddRow()};
  cell6.appendChild(SPAN);
  var tbody = demoT.createTBody();
  //setSchTableSortable();
  /* row = demoT.insertRow(-1);
  cell0 = row.insertCell(0);
  cell1 = row.insertCell(1);
  cell2 = row.insertCell(2);
  cell3 = row.insertCell(3);
  cell4 = row.insertCell(4);
  var Div0=document.createElement('div');
  Div0.innerHTML=0;
  Div0.setAttribute("contenteditable","true");
  cell0.appendChild(Div0); */
  //var Div4=document.createElement('span');
  //Div4.setAttribute("class","table-remove glyphicon glyphicon-remove");
  //Div4.onclick=function(e){var child=this.parentNode.parentNode; var tparent=child.parentNode; tparent.removeChild(child); plotLineFromSchTable()};
  //cell4.appendChild(Div4);

}
export function collectShipborneEquips(){
  gvar.cPlanInfo.shipborne={}
  let tmpobjs=$('[id*=ShipborneEquipmentList_]')
  tmpobjs.each(function (index){
    let equipId=$(this).prop('id').replace("ShipborneEquipmentList_","");
    gvar.equipments[equipId][1]=$(this).prop('checked')
    gvar.cPlanInfo.shipborne[equipId]=gvar.equipments[equipId]
  })
}
function buildChkList(elementId,items){
  let tmpObj=$('#'+elementId)
  tmpObj.empty();
  let htmlstr=''
  let checked=''
  //console.log(gvar.cPlanInfo.shipborne)
  if (gvar.cPlanInfo.shipborne){
    for (const [key, value] of Object.entries(gvar.cPlanInfo.shipborne)){
      //console.log(key)
      //console.log(value)
      gvar.equipments[key][1]=value[1]
    }
  }
  htmlstr+=`<div class="row">`
  let t2=~~((items.length+1)/2)
  htmlstr+=`<div class="col-md-6">`
  for (let i=0; i<t2; i+=1){
    let mykey=items[i]
    let myname=gvar.equipments[mykey][0]
    let myid=`${elementId}_${mykey}`
    if (gvar.equipments[mykey][1]){
      checked='checked'
    }else{
      checked=''
    }
    htmlstr+=`<input type='checkbox' class='form-check-input' id='${myid}' ${checked}>`
    htmlstr+=`<label class='form-check-label' for='${myid}'>${myname};</label><br>`
  } 
  htmlstr+=`</div>`
  htmlstr+=`<div class="col-md-6">`
  for (let i=t2; i<items.length; i+=1){
    let mykey=items[i]
    let myname=gvar.equipments[mykey][0]
    let myid=`${elementId}_${mykey}`
    if (gvar.equipments[mykey][1]){
      checked='checked'
    }else{
      checked=''
    }
    htmlstr+=`<input type='checkbox' class='form-check-input' id='${myid}' ${checked}>`
    htmlstr+=`<label class='form-check-label' for='${myid}'>${myname};</label><br>`
  } 
  htmlstr+=`</div>`
  htmlstr+=`</div>`
  tmpObj.append(htmlstr)
}
function buildCplanLayerList(){
  let tmpObj=document.getElementById('CPlanLayerList')
  var fragment=document.createDocumentFragment();
  if (tmpObj.childNodes.length==0){
    $.getJSON('/odbintl/rasters/getcPlanList/', function(data) {
      for (let tmpi=0; tmpi<data.length; tmpi++){
        var oplanname=data[tmpi].fields.name;
        var planname="sel_"+data[tmpi].fields.name;
        var  LABEL=document.createElement('label');
        LABEL.setAttribute("class","checkbok");
        LABEL.setAttribute("for",planname);
        var INPUT=document.createElement('input');
        INPUT.setAttribute("id",planname);
        INPUT.setAttribute("class","visible");
        INPUT.setAttribute("type","checkbox");
        var TEXT=document.createTextNode(oplanname+";  ");
        LABEL.appendChild(INPUT);
        LABEL.appendChild(TEXT);
        fragment.appendChild(LABEL);
      };
      tmpObj.appendChild(fragment);
      $(tmpObj).children('label').children('input').click(
        function(){
          this.disabled=true;
          switchCplanLayer(this);
        }
      )
    });       
  }
}
function switchCplanLayer(thisobj){
  let planname=thisobj.id.replace('sel_','');
  var getplanurl='/odbintl/rasters/getcplan/?name=';
  getplanurl += encodeURIComponent(planname);
  if (thisobj.checked){
    if (! gvar.cplanHistFeatures[planname]){
      $.getJSON(getplanurl, function(data) {
        var features=(new OlFormatGeoJSON()).readFeatures(data,{
          featureProjection:'EPSG:3857'
        })
        gvar.cplanHistFeatures[planname]=features;
        gvar.Layers.Cplan.getSource().addFeatures(features);
        thisobj.disabled=false;
      })
    }else{
      let tmpfeatures=gvar.cplanHistFeatures[planname]
      gvar.Layers.Cplan.getSource().addFeatures(tmpfeatures)
      thisobj.disabled=false;
    }
  }else{
    let tmpfeatures=gvar.cplanHistFeatures[planname]
    for (let i=0 ; i< tmpfeatures.length; i++){
      gvar.Layers.Cplan.getSource().removeFeature(tmpfeatures[i])
      thisobj.disabled=false;
    }  
  }
}
function iniShipTrackLayerList(){
  var tmpObj=document.getElementById('ShipTrackLayerList');
  var  LABEL=document.createElement('label');
  for (let yr=2010; yr<2015; yr++){
    var layername="or1_"+yr.toString();
    LABEL.setAttribute("class","checkbok");
    LABEL.setAttribute("for",layername);
    var INPUT=document.createElement('input');
    INPUT.setAttribute("id",layername);
    INPUT.setAttribute("class","visible");
    INPUT.setAttribute("type","checkbox");
    INPUT.setAttribute("onclick","switchShipTrackLayer('"+layername+"')");
    var TEXT=document.createTextNode(layername+"; ");
    LABEL.appendChild(INPUT);
    LABEL.appendChild(TEXT);
    tmpObj.appendChild(LABEL);
  }
}
function SchTableAddRow(pid){
  const schTableId="SchTable"
  var TBody=document.getElementById(schTableId).getElementsByTagName('tbody')[0];
  gvar.autoSchID+=1;
  var row = TBody.insertRow(TBody.rows.length);
  var cell0 = row.insertCell(0);
  var cell1 = row.insertCell(1);
  var cell2 = row.insertCell(2);
  var cell3 = row.insertCell(3);
  var cell4 = row.insertCell(4);
  var cell5 = row.insertCell(5);
  var cell6 = row.insertCell(6);
  cell1.setAttribute("style","color:#ccc;");
  var Div0=document.createElement('div');
  if (pid !== undefined){
    Div0.innerHTML=pid;
  }
  Div0.setAttribute("contenteditable","true");
  cell0.appendChild(Div0);
  var stahr="0.0"
  var workItem='{"item":["PT"],"other":""}'
  var Div4=document.createElement('div');
  Div4.setAttribute("contenteditable","true");
  Div4.innerText=stahr;
  cell4.appendChild(Div4);
  var Div5=document.createElement('div');
  if (document.getElementById("setWorkItem").checked){
    Div5.setAttribute("class","workItem");
  }else{
    Div5.setAttribute("class","workItem hide");
  }
  var tmpSpan=document.createElement('SPAN');
  tmpSpan.innerHTML=workItem2show(workItem);
  Div5.setAttribute("wkdata",workItem);//
  var tmpwkitemid="wkitem"+gvar.autoSchID
  cell5.setAttribute("id",tmpwkitemid);
  Div5.appendChild(tmpSpan);
  cell5.appendChild(Div5);
  var c6Span1=document.createElement('span');
  c6Span1.setAttribute("class","table-remove glyphicon glyphicon-remove");
  cell6.appendChild(c6Span1);
	
  var Div2=document.createElement('div');
  Div2.innerHTML="8.0";
  Div2.setAttribute("contenteditable","true");
  cell2.appendChild(Div2);
  var Div3=document.createElement('div');
  Div3.setAttribute("contenteditable","true");
  cell3.appendChild(Div3);
  if (TBody.rows.length > 1 ){
  }else{
    if (pid == undefined){
      SchTableAddRow();
    }
  }
  $(Div0).click(function(){selectText(this);});
  $(Div2).click(function(){
    gvar.chkShipSpdByHrs=false;
    selectText(this);
  });
  $(Div3).click(function(){
    gvar.chkShipSpdByHrs=true;
    selectText(this);
  });
  $(Div4).click(function(){selectText(this);})
  $(cell5).click(function(){
    //console.log($(this).children().attr("wkdata"))
    buildWorkItem(tmpwkitemid,$(this).children().attr("wkdata"));
  })
  $(c6Span1).click(function(e){
    var child=this.parentNode.parentNode; 
    var tparent=child.parentNode; 
    tparent.removeChild(child); 
    $.when(plotLineFromSchTable()).then(function(){
      gvar.cPlanJSON.line=gvar.SchData.line;
    });
    //plotLineFromSchTable();
    //gvar.cPlanJSON.line=gvar.SchData.line
  });
  return row
}
function moverow(cellobj){
    var tmprow=cellobj.closest('tr');
    if (cellobj.hasClass('table-moveup')){
      if (tmprow.index()>2){
        tmprow.prev().before(tmprow);
      }
    }else{
      if (tmprow.index()>1){
        tmprow.next().after(tmprow);
      }
    }
    //console.log('abc')
    plotLineFromSchTable();
    gvar.cPlanJSON.line=gvar.SchData.line
}
/*
*/
